import React from 'react';
import http from '../../modules/api';
import * as StringUtil from '../../modules/utils/StringUtil';
import SaveDialogV2 from '../../modules/dialogs/SaveDialogV2';
import WarningDialog from '../../modules/dialogs/WarningDialog';
import TitleContentDialogV2 from '../../modules/dialogs/TitleContentDialogV2';
import InputDialogV3 from '../../modules/dialogs/InputDialogV3';

let is_test_use = "";
if (document.domain.indexOf("127.0.0.1") >= 0 || document.domain.indexOf("otdeal.me") >= 0) {
    is_test_use = "&is_test_use=Y"
}


const stability_prompt = {
    52000: 'style_type_list',
    53000: 'composition_type_list',
    54000: 'ratio_list',
};

const prompt_max_length = 1000;

const style_css = `
@keyframes aiImageStudioSpin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

@keyframes aiImageStudioFadeIn {
    0% { opacity: 0; }
    100% { opacity: 1; }
}

@keyframes aiImageStudioSlideUp {
    0% {
        opacity: 0;
        transform: translateY(20px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes aiImageStudioLoadBar {
    0% { transform: translateX(-100%); }
    100% { transform: translateX(200%); }
}

@keyframes aiImageStudioApplyRuleSpin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.ai-image-studio-workflow { font-family: 'Noto Sans KR', 'Lato', sans-serif; background-color: var(--bg-color); color: var(--text-main); line-height: 1.6; font-size: 15px; min-height: 100vh; display: flex; flex-direction: column; }
.ai-image-studio-workflow {
    --primary-mint: #00e2e6;
    --primary-mint-hover: #00bfc2;
    --deep-navy: #0A1A2F;
    --deep-navy-hover: #1f2937;
    --bg-color: #f9fafb;
    --border-color: #e5e7eb;
    --text-main: #0A1A2F;
    --text-sub: #6b7280;
    --text-light: #9ca3af;
    --white: #ffffff;
    --radius-lg: 16px;
    --radius-md: 12px;
    --radius-sm: 8px;
    }

.ai-image-studio-workflow * { margin: 0; padding: 0; box-sizing: border-box; }
.ai-image-studio-workflow {
    .svg-icon { width: 22px; height: 22px; display: inline-block; vertical-align: middle; flex-shrink: 0; fill: currentColor; }
    .svg-icon-sm { width: 18px; height: 18px; display: inline-block; vertical-align: middle; flex-shrink: 0; fill: currentColor; }
    .svg-icon-lg { width: 28px; height: 28px; display: inline-block; vertical-align: middle; flex-shrink: 0; fill: currentColor; }
    .svg-stroke { fill: none; stroke: currentColor; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
    ::-webkit-scrollbar { width: 8px; height: 8px; }
    ::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }
    ::-webkit-scrollbar-track { background: transparent; }
    .header-row { position: sticky; top: 0; z-index: 100; display: flex; align-items: center; justify-content: space-between; background: var(--white); padding: 16px 32px; border-bottom: 1px solid var(--border-color); box-shadow: 0 2px 10px rgba(10, 26, 47, 0.05); }
    .page-title { font-size: 24px; font-weight: 800; display: flex; align-items: center; gap: 10px; color: var(--deep-navy); }
    .page-title::before { content: ''; width: 6px; height: 24px; background: var(--primary-mint); border-radius: 3px; display: block; }
    .header-actions { display: flex; align-items: center; gap: 12px; }
    .main-container { flex: 1; padding: 40px 24px; max-width: 1040px; width: 100%; margin: 0 auto; }
    .btn { height: 46px; padding: 0 24px; border-radius: var(--radius-sm); font-size: 15px; font-weight: 700; cursor: pointer; border: none; transition: 0.2s; display: inline-flex; align-items: center; justify-content: center; gap: 8px; white-space: nowrap; }
    .btn-primary { background: var(--primary-mint); color: var(--deep-navy); box-shadow: 0 2px 8px rgba(0, 226, 230, 0.2); }
    .btn-primary:hover { background: var(--primary-mint-hover); transform: translateY(-1px); box-shadow: 0 4px 12px rgba(0, 226, 230, 0.3); }
    .btn-secondary { background: var(--deep-navy); color: var(--white); box-shadow: 0 2px 8px rgba(10, 26, 47, 0.1); }
    .btn-secondary:hover { background: var(--deep-navy-hover); transform: translateY(-1px); }
    .btn-outline { background: var(--white); color: var(--deep-navy); border: 2px solid var(--border-color) !important; }
    .btn-outline.btn-outline-red { color: #dc2626 !important; border-color: #fecaca !important; }
    .btn-outline:hover { border-color: var(--primary-mint) !important; background: #f0fdfe !important; }
    .btn-sm { height: 38px; padding: 0 16px; font-size: 14px; }
    .card { background: var(--white); border-radius: var(--radius-md); border: 1px solid var(--border-color); padding: 36px; margin-bottom: 24px; box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03); }
    .card-header { margin-bottom: 24px; }
    .card-title { font-size: 20px; font-weight: 800; color: var(--deep-navy); margin-bottom: 8px; display: flex; align-items: center; gap: 8px; }
    .rule-applied-container { background: #f8fafc; border-radius: var(--radius-md); padding: 24px; display: flex; gap: 24px; align-items: stretch; border: 1px solid var(--border-color); }
    .rule-type-box { width: 150px; border: 2px solid #67e8f9; border-radius: 12px; background: #ecfeff; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 16px; flex-shrink: 0; position: relative; overflow: hidden; background-size: cover; background-position: center; }
    .rule-prompt-box { flex: 1; background: var(--white); border: 1px solid var(--border-color); border-radius: var(--radius-sm); padding: 20px; }
    .rule-prompt-title { font-size: 16px; font-weight: 800; color: var(--deep-navy); margin-bottom: 16px; padding-bottom: 12px; border-bottom: 1px solid var(--border-color); display: flex; justify-content: space-between; }
    .rule-prompt-list { font-size: 15px; color: var(--deep-navy); margin: 0; padding-left: 0; list-style: none; display: flex; flex-direction: column; gap: 12px; }
    .rule-prompt-list li { background: #f8fafc; padding: 14px 16px; border-radius: 8px; border: 1px solid #e2e8f0; }
    .modal-overlay { display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,.45); z-index: 9999; align-items: center; justify-content: center; backdrop-filter: blur(4px); }
    .modal-overlay.active { display: flex; animation: aiImageStudioFadeIn 0.2s ease; }
    .modal-box { background: #ffffff !important; width: 98vw !important; max-width: 1700px !important; height: 95vh !important; border-radius: var(--radius-lg) !important; box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.4) !important; display: flex !important; flex-direction: column !important; overflow: hidden !important; padding: 0 !important; }
    .full-page-mode {
        width: 100% !important;
        max-width: none !important;
        height: 100vh !important;
        height: 100dvh !important;
        border-radius: 0 !important;
        box-shadow: none !important;
    }
    .studio-header { display: flex; justify-content: space-between; align-items: center; padding: 16px 24px; background: #0f172a; color: white; }
    .studio-logo { font-size: 20px; font-weight: 800; color: white; display: flex; align-items: center; gap: 8px; }
    .studio-top-nav { display: flex; gap: 4px; }
    .studio-top-nav button { background: transparent; border: none; color: #94a3b8; padding: 8px 16px; font-size: 15px; font-weight: 700; cursor: pointer; border-radius: 6px; transition: 0.2s; }
    .studio-top-nav button:hover { background: rgba(255,255,255,0.1); color: white; }
    .studio-top-nav button.active { background: rgba(0, 226, 230, 0.15); color: var(--primary-mint); }
    .studio-body { display: flex; flex: 1; overflow: hidden; background: #f8fafc; }
    .studio-sidebar { width: 280px; background: white; border-right: 1px solid var(--border-color); display: flex; flex-direction: column; flex-shrink: 0; }
    .sidebar-header { padding: 20px 24px; border-bottom: 1px solid var(--border-color); }
    .new-chat-btn { width: 100%; display: flex; justify-content: space-between; align-items: center; padding: 14px 16px; background: white; border: 1px solid #cbd5e1; border-radius: var(--radius-sm); font-weight: 700; font-size: 15px; color: var(--deep-navy); cursor: pointer; transition: 0.2s; box-shadow: 0 2px 4px rgba(0,0,0,0.02); }
    .new-chat-btn:hover { border-color: var(--primary-mint); color: var(--primary-mint-hover); background: #f0fdfe; }
    .history-list { flex: 1; overflow-y: auto; padding: 12px; display: flex; flex-direction: column; gap: 4px; }
    .history-group-title { font-size: 13px; font-weight: 800; color: #94a3b8; padding: 12px 12px 4px 12px; text-transform: uppercase; }
    .history-item { max-width: 100%; min-height: 38px; padding: 8px 8px 8px 16px; border-radius: 8px; cursor: pointer; display: flex; align-items: center; gap: 8px; transition: 0.2s; color: var(--text-main); font-size: 15px; font-weight: 500; position: relative; overflow: visible; }
    .history-item.active { background: #e0f2fe !important; color: #0369a1; font-weight: 700; }
    .history-item:hover { background: #e0f2fe97 }
    .history-item-text { min-width: 0; flex: 1 1 auto; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .history-menu-wrap { position: relative; flex: 0 0 auto; }
    .history-menu-trigger { width: 25px; height: 25px; display: inline-flex; align-items: center; justify-content: center; padding: 0; border: 0; border-radius: 5px; background: transparent; color: #94a3b8; font-size: 17px; font-weight: 800; line-height: 1; cursor: pointer; }
    .history-menu-trigger:hover { background: #ffffff; color: var(--deep-navy); }
    .history-menu { position: absolute; top: 28px; right: 0; z-index: 30; min-width: 88px; padding: 5px; border: 1px solid #dbe3ea; border-radius: 7px; background: #ffffff; box-shadow: 0 8px 22px rgba(15, 23, 42, 0.16); }
    .history-menu button { width: 100%; display: block; padding: 7px 9px; border: 0; border-radius: 5px; background: transparent; color: #475569; font-size: 12px; font-weight: 600; text-align: left; cursor: pointer; white-space: nowrap; }
    .history-menu button:hover { background: #f1f5f9; }
    .history-menu button.delete { color: #dc2626; }
    .studio-main-wrap { flex: 1; display: flex; flex-direction: column; overflow: hidden; position: relative; background: #f1f5f9; }
    .chat-feed { flex: 1; overflow-y: auto; padding: 40px; display: flex; flex-direction: column; scroll-behavior: smooth; background: #f1f5f9; }
    .step-node { display: flex; gap: 24px; width: 100%; max-width: 1300px; margin: 0 auto 60px auto; position: relative; align-items: stretch; animation: aiImageStudioSlideUp 0.4s ease; }
    .node-timeline-track { display: flex; flex-direction: column; align-items: center; flex-shrink: 0; width: 44px; margin-right: 10px; position: relative; }
    .node-number { width: 44px; height: 44px; border-radius: 50%; background: white; color: var(--text-sub); display: flex; align-items: center; justify-content: center; font-size: 18px; font-weight: 900; border: 2px solid #e2e8f0; position: relative; z-index: 2; transition: 0.2s; }
    .timeline-line { width: 2px; height: calc(100% + 60px); background: #cbd5e1; position: absolute; top: 44px; left: 21px; z-index: 1; display: none; }
    .step-node.active .node-number { background: var(--primary-mint); border-color: var(--primary-mint); color: var(--deep-navy); box-shadow: 0 0 0 4px rgba(0,226,230,0.2); }
    .step-node.has-next .timeline-line { display: block; }
    .node-content-split { display: flex; flex: 1; gap: 24px; min-width: 0; }
    .config-pane { flex: 1; background: white; border: 1px solid var(--border-color); border-radius: var(--radius-lg); box-shadow: 0 4px 15px rgba(0,0,0,0.03); display: flex; flex-direction: column; overflow: hidden; transition: 0.3s; }
    .step-node.active .config-pane { border: 2px solid var(--primary-mint); box-shadow: 0 8px 30px rgba(0,226,230,0.15); }
    .node-header { min-height: 62px; padding: 9px 22px; display: flex; justify-content: space-between; align-items: center; gap: 16px; background: #f9fafc; border-bottom: 1px solid #e6e7e9; }
    .node-title-wrap { min-width: 0; display: flex; align-items: center; gap: 16px; }
    .node-badge { display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0; min-width: 59px; height: 30px; padding: 0 12px; border: 1px solid #00e2e6; border-radius: 15px; background: #dffafa; color: #336389; font-size: 13px; font-weight: 700; line-height: 1; }
    .node-title-text { min-width: 0; color: #080909; font-size: 16px; font-weight: 700; line-height: 1.4; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .prompt-flex-box { display: flex; align-items: center; gap: 12px; background: var(--white); border: 2px solid var(--border-color); border-radius: var(--radius-md); padding: 12px 16px; margin: 20px 24px; transition: all 0.2s; }
    .prompt-flex-box:focus-within { border-color: var(--primary-mint); box-shadow: 0 0 0 4px rgba(0,226,230,0.1); }
    .ai-image-studio-workflow .fa, .image-zoom-overlay .fa { font-family: "Font Awesome 6 Free" !important; font-style: normal; font-weight: 900; }
    .sample-scene-guide { margin: 20px 24px 0; padding: 12px 14px; border: 1px solid var(--border-color); border-radius: 10px; background: #f8fafc; position: relative; }
    .sample-scene-guide.has-result-example { padding-right: 84px; }
    .sample-scene-guide-title { color: var(--deep-navy); font-size: 13px; font-weight: 800; line-height: 1.4; margin-bottom: 4px; }
    .sample-scene-guide-text { color: var(--text-sub); font-size: 13px; line-height: 1.55; }
    .sample-result-example-thumb { position: absolute; top: 50%; right: 12px; transform: translateY(-50%); width: 58px; height: 48px; padding: 0; border: 1px solid #dbe3ea; border-radius: 7px; background: #ffffff; overflow: hidden; cursor: zoom-in; box-shadow: 0 2px 8px rgba(15,23,42,0.08); }
    .sample-result-example-thumb:hover { border-color: var(--primary-mint); box-shadow: 0 3px 10px rgba(0,226,230,0.16); }
    .sample-result-example-thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }
    .sample-result-example-label { position: absolute; left: 0; right: 0; bottom: 0; padding: 2px 3px; background: rgba(10,26,47,0.78); color: #fff; font-size: 9px; font-weight: 800; line-height: 1.2; text-align: center; pointer-events: none; }
    .prompt-actions-left, .prompt-actions-right { flex-shrink: 0; padding-bottom: 4px; display: flex; align-items: center; }
    .icon-btn-round { width: 44px; height: 44px; border-radius: 50%; border: none; background: transparent; color: var(--text-sub); display: flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s; }
    .icon-btn-round:hover { background: #f1f5f9; color: var(--deep-navy); }
    .prompt-input-area { flex: 1; display: flex; flex-direction: column; gap: 12px; }
    .upload-preview-inline { width: 85px; height: 85px; border-radius: 8px; border: 1px solid var(--border-color); background-size: cover; background-position: center; position: relative; box-shadow: 0 2px 8px rgba(0,0,0,0.05); margin-top: 8px; animation: aiImageStudioFadeIn 0.2s ease; }
    .source-waiting-inline { width: 85px; height: 85px; flex-shrink: 0; border: 1px dashed #cbd5e1; border-radius: 8px; background: #f8fafc; color: #64748b; display: flex; align-items: center; justify-content: center; padding: 8px; margin-top: 8px; font-size: 11px; font-weight: 700; text-align: center; line-height: 1.35; }
    .remove-preview-btn { position: absolute; top: -8px; right: -8px; background: var(--white); border: 1px solid var(--border-color); width: 24px; height: 24px; border-radius: 50%; cursor: pointer; display: flex; align-items: center; justify-content: center; z-index: 5; transition: 0.2s; box-shadow: 0 2px 4px rgba(0,0,0,0.1); color: var(--text-main); }
    .remove-preview-btn:hover { background: #fecaca; color: #dc2626; border-color: #fca5a5; }
    .source-label { position: absolute; bottom: 0; left: 0; right: 0; background: rgba(10,26,47,0.7); color: white; font-size: 11px; font-weight: 700; text-align: center; padding: 2px 0; border-bottom-left-radius: 7px; border-bottom-right-radius: 7px; }
    .prompt-textarea { width: 100%; border: none; font-size: 16px; font-weight: 500; color: var(--deep-navy); line-height: 1.5; resize: vertical; outline: none; background: transparent; height: auto; min-height: 24px; overflow-y: hidden; border: none !important; padding: 0px !important;}
    .prompt-textarea::placeholder { color: #cbd5e1; font-weight: 400; }
    .automation-use-warning { flex-shrink: 0; margin: 16px 40px 0; padding: 12px 14px; border: 1px solid #ef4444; border-radius: 8px; background: #fff; color: #dc2626; display: flex; align-items: center; gap: 10px; flex-wrap: wrap; font-size: 13px; line-height: 1.5; z-index: 5; }
    .automation-use-warning strong { font-weight: 800; white-space: nowrap; }
    .automation-use-warning .automation-use-warning-text { flex: 1; min-width: 220px; }
    .automation-use-warning .automation-use-warning-button { height: 34px; padding: 0 14px; border: 1px solid #ef4444; border-radius: 7px; background: #fff; color: #dc2626; font-size: 12px; font-weight: 800; cursor: pointer; white-space: nowrap; }
    .automation-use-warning .automation-use-warning-button:hover { background: #fef2f2; }
    .automation-protected-disabled { opacity: 0.62; }
    .automation-protected-disabled .prompt-textarea { cursor: not-allowed; }
    .icon-btn-submit { width: 46px; height: 46px; border-radius: 50%; border: none; background: #080909; color: #ffffff; display: flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s; }
    .icon-btn-submit:hover { background: #202020; color: #ffffff; transform: translateY(-1px); }
    .icon-btn-submit .svg-icon-lg { width: 24px; height: 24px; }
    .icon-btn-submit:disabled {
        background: var(--border-color);
        color: var(--text-light);
        cursor: not-allowed;
    }
    .node-settings { padding: 0 24px 24px 24px; }
    .setting-section-title { font-size: 13px; font-weight: 700; color: #64748b; margin-bottom: 10px; display: block; }
    .pill-option-group { display: flex; flex-wrap: wrap; gap: 10px; }
    .pill-option-btn { display: inline-flex; align-items: center; gap: 8px; padding: 4px 16px 4px 4px; border: 1px solid var(--border-color); border-radius: 30px; background: var(--white); cursor: pointer; transition: all 0.2s ease; }
    .pill-option-btn:hover { border-color: var(--primary-mint); background: #f8fafc; }
    .pill-option-btn.active { border-color: var(--primary-mint); background: #ecfeff; }
    .pill-option-btn.active .pill-option-text { color: #0369a1; }
    .pill-icon-thumb { width: 28px; height: 28px; border-radius: 50%; background-size: cover; background-position: center; border: 1px solid #e5e7eb; display: flex; align-items: center; justify-content: center; background-color: #f3f4f6; }
    .pill-option-text { font-size: 14px; font-weight: 700; color: var(--text-sub); }
    .config-pane-footer { min-height: 62px; padding: 9px 22px; border-top: 1px solid var(--border-color); background: #f8fafc; display: flex; justify-content: flex-end; align-items: center; gap: 10px; }
    .result-pane { width: 380px; flex-shrink: 0; display: flex; flex-direction: column; background: white; border: 1px solid var(--border-color); border-radius: var(--radius-lg); box-shadow: 0 4px 15px rgba(0,0,0,0.03); overflow: hidden; transition: 0.3s; }
    .step-node.active .result-pane { border-color: var(--primary-mint); box-shadow: 0 8px 30px rgba(0,226,230,0.15); }
    .result-header { padding: 20px 24px; border-bottom: 1px solid var(--border-color); font-weight: 800; font-size: 16px; color: var(--deep-navy); display: flex; justify-content: space-between; align-items: center; background: #f8fafc; }
    .canvas-wrap { padding: 24px; flex: 1; display: flex; flex-direction: column; }
    .preview-canvas-container { width: 100%; background: white; border: 1px solid var(--border-color); border-radius: var(--radius-md); box-shadow: 0 4px 12px rgba(0,0,0,0.04); overflow: hidden; display: flex; flex-direction: column; position: relative; aspect-ratio: 4/5; transition: 0.3s; }
    .preview-canvas-container.has-result { border-color: transparent; box-shadow: 0 4px 20px rgba(0,0,0,0.1); }
    .canvas-default-state { flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; color: #94a3b8; gap: 12px; background: var(--bg-color); }
    .loading-state { flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; background: var(--bg-color); }
    .loading-bar-container { width: 60%; height: 6px; background: var(--border-color); border-radius: 3px; margin-top: 16px; overflow: hidden; }
    .loading-bar { width: 50%; height: 100%; background: var(--primary-mint); animation: aiImageStudioLoadBar 1.5s ease-in-out infinite; will-change: transform; }
    .preview-canvas-image { position: absolute; inset: 0; background-size: cover; background-position: center; transition: background-image 0.4s ease; }
    .preview-status-badge { display: none; position: absolute; top: 12px; left: 12px; background: rgba(10,26,47,0.85); color: white; padding: 6px 14px; font-size: 13px; font-weight: 800; border-radius: 20px; z-index: 5; }
    .download-icon-btn { position: absolute; top: 12px; right: 12px; width: 36px; height: 36px; border-radius: 8px; background: rgba(255, 255, 255, 0.95) url('https://robomd.io/static/media/download.4d4832f6.svg') center/20px no-repeat; cursor: pointer; z-index: 10; box-shadow: 0 2px 8px rgba(0,0,0,0.15); transition: 0.2s; border: 1px solid rgba(0,0,0,0.05); display: flex; align-items: center; justify-content: center; }
    .download-icon-btn:hover { background-color: #ffffff; transform: translateY(-2px); box-shadow: 0 4px 12px rgba(0,0,0,0.2); }
    .expand-icon-btn { position: absolute; top: 12px; right: 56px; width: 36px; height: 36px; border-radius: 8px; background: rgba(255,255,255,0.95); color: var(--deep-navy); cursor: pointer; z-index: 10; box-shadow: 0 2px 8px rgba(0,0,0,0.15); transition: 0.2s; border: 1px solid rgba(0,0,0,0.05); display: flex; align-items: center; justify-content: center; }
    .expand-icon-btn:hover { background: #ffffff; color: var(--primary-dark); transform: translateY(-2px); box-shadow: 0 4px 12px rgba(0,0,0,0.2); }
    .expand-icon-btn i { font-size: 16px; }
    .tutorial-demo-badge { position: absolute; left: 12px; top: 12px; z-index: 11; padding: 6px 10px; border-radius: 999px; background: rgba(15, 35, 40, 0.84); color: #fff; font-size: 12px; font-weight: 700; letter-spacing: -0.2px; }
    .history-nav-overlay { position: absolute; bottom: 16px; left: 50%; transform: translateX(-50%); background: rgba(10, 26, 47, 0.75); backdrop-filter: blur(4px); border: 1px solid rgba(255,255,255,0.2); color: white; padding: 6px 16px; border-radius: 24px; display: flex; align-items: center; gap: 16px; z-index: 10; box-shadow: 0 4px 12px rgba(0,0,0,0.2); }
    .history-nav-btn { cursor: pointer; display: flex; align-items: center; justify-content: center; width: 24px; height: 24px; border-radius: 50%; transition: 0.2s; }
    .history-nav-btn:hover { background: rgba(255,255,255,0.2); }
    .history-nav-btn.disabled { opacity: 0.3; cursor: not-allowed; }
    .workspace-footer { background: white; padding: 20px 32px; border-top: 1px solid var(--border-color); display: flex; justify-content: space-between; align-items: center; box-shadow: 0 -4px 20px rgba(10,26,47,0.05); z-index: 20; min-height: 100.78px; }
    
    .btn:disabled {
        background: var(--border-color);
        color: var(--text-light);
        border-color: var(--border-color);
        cursor: not-allowed;
        transform: none;
        box-shadow: none;
    }
    .btn-outline:disabled:hover {
        background: var(--border-color) !important;
        color: var(--text-light) !important;
        border-color: var(--border-color) !important;
    }
    
    .btn-save-workflow { background: #53dee3 !important; color: #0b1a2d !important; box-shadow: none !important; }
    .btn-save-workflow:hover { background: #45d1d6 !important; color: #0b1a2d !important; transform: none !important; box-shadow: none !important; }
    .btn-save-workflow:disabled, .btn-save-workflow:disabled:hover { background: var(--border-color) !important; color: var(--text-light) !important; cursor: not-allowed; transform: none !important; }

    .usage-summary-box {
        display: flex;
        flex-direction: column;
        gap: 4px;
        background: #f8fafc;
        border: 1px solid var(--border-color);
        /* border-radius: 12px; */
        padding: 12px 25px;
        min-width: 125px;
        text-align: center;
    }

    .usage-summary-title {
        font-size: 12px;
        font-weight: 700;
        color: var(--text-sub);
        text-align: center;
    }

    .usage-summary-body {
        display: flex;
        // flex-direction: column;
        gap: 4.5%;
        text-align: center;
        justify-content: center;
    }

    .usage-main-text {
        font-size: 15px;
        font-weight: 800;
        color: var(--deep-navy);
    }

    .usage-separator {
        color: var(--text-light);
    }

    .usage-sub-text {
        font-size: 12px;
        font-weight: 600;
        color: #0284c7;
    }

    .usage-loading-text {
        font-size: 14px;
        font-weight: 600;
        color: var(--text-sub);
    }

    .usage-metric-group {
        display: flex;
        flex-direction: column;
        gap: 2px;
    }

    .usage-metric-label {
        font-size: 12px;
        font-weight: 700;
        color: var(--text-sub);
    }

    .usage-summary-divider {
        width: 1px;
        height: 100%;
        margin: 7px 0;
        background: var(--border-color);
    }

    .mobile-history-btn {
        display: none;
        background: rgba(255,255,255,0.08);
        border: 1px solid rgba(255,255,255,0.18);
        color: #ffffff;
    }

    .mobile-history-btn:hover {
        background: rgba(255,255,255,0.16) !important;
        color: #ffffff !important;
        border: 1px solid rgba(255,255,255,0.18) !important;
    }

    .mobile-history-backdrop {
        display: none;
    }

    .history-filter-wrap {
        display: flex;
        gap: 8px;
        padding: 12px 16px;
    }

    .history-filter-btn {
        flex: 1;
        height: 36px;
        border-radius: 8px;
        border: 1px solid var(--border-color);
        background: #ffffff;
        font-size: 13px;
        font-weight: 700;
        color: var(--text-sub);
        cursor: pointer;
        transition: all 0.2s ease;
    }

    /* hover */
    .history-filter-btn:hover {
        border-color: var(--primary-mint);
        background: #f8fafc;
        /* color: var(--primary-mint-hover); */
    }

    /* active (선택됨) */
    .history-filter-btn.active {
        /* background: var(--primary-mint); */
        border: 1px solid var(--primary-mint);
        color: #0369a1;
        /* box-shadow: inset 0px 0px 0px 0.5px var(--primary-mint); */
        background: #ecfeff;
    }

    
    @media (min-width: 1024px) {
        .workspace-footer { gap: 1.2vw; }
    }

    @media (max-width: 1024px) {
        .popup-mode { position: relative; }

        .mobile-history-btn {
            display: inline-flex;
        }

        .mobile-history-backdrop {
            display: block;
            position: fixed;
            inset: 0;
            background: rgba(15, 23, 42, 0.45);
            z-index: 120;
        }

        .popup-mode .mobile-history-backdrop {
            position: absolute;
            inset: 0;
        }

        .studio-sidebar {
            display: flex !important;
            position: fixed;
            top: 0;
            left: 0;
            width: min(82vw, 320px);
            height: 100vh;
            height: 100dvh;
            z-index: 130;
            transform: translateX(-100%);
            transition: transform 0.25s ease;
            box-shadow: 0 10px 30px rgba(0,0,0,0.18);
        }

        .studio-sidebar.mobile-open {
            transform: translateX(0);
        }

        /* 팝업일 때만 덮어쓰기 */
        .popup-mode .studio-sidebar {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
        }

        .node-content-split { flex-direction: column; }
        .result-pane { width: 100%; height: auto; }
        .preview-canvas-container { max-height: 500px; margin: 0 auto; max-width: 400px; }
        .workspace-footer { flex-direction: column; gap: 16px; text-align: center; padding: 16px; }
        .workspace-footer > div { 
            width: 100%; 
            justify-content: center; 
            /* flex-wrap: wrap; */ 
        }
        .usage-summary-box {
            width: 100%;
            min-width: 0;
            text-align: center;
        }
    }
    .apply-rule-loading-overlay {
        position: absolute;
        inset: 0;
        z-index: 5000;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(10, 26, 47, 0.48);
        backdrop-filter: blur(2px);
    }
    .apply-rule-loading-box {
        min-width: 320px;
        max-width: calc(100% - 40px);
        padding: 28px 32px;
        border-radius: 16px;
        background: #fff;
        box-shadow: 0 18px 48px rgba(10, 26, 47, 0.24);
        text-align: center;
        color: var(--deep-navy);
    }
    .apply-rule-loading-spinner {
        width: 36px;
        height: 36px;
        margin: 0 auto 18px;
        border: 4px solid #dffbfc;
        border-top-color: var(--primary-mint);
        border-radius: 50%;
        animation: aiImageStudioApplyRuleSpin 0.85s linear infinite;
        transform-origin: center;
        will-change: transform;
    }
    .apply-rule-loading-line1 {
        font-size: 16px;
        font-weight: 700;
        line-height: 1.5;
    }
    .apply-rule-loading-line2 {
        margin-top: 6px;
        font-size: 14px;
        color: var(--text-sub);
    }
    @media (max-width: 800px) {
        .header-row { padding: 12px 16px; }
        .page-title { font-size: 18px; }
        .main-container { padding: 20px 16px; }
        .card { padding: 24px 20px; }
        .rule-applied-container { flex-direction: column; padding: 16px; gap: 16px; }
        .rule-type-box { width: 100%; height: 120px; }
        .chat-feed { padding: 20px 16px; }
        .automation-use-warning { margin: 12px 16px 0; }
        .step-node { gap: 12px; margin-bottom: 30px; }
        .node-timeline-track { width: 32px; margin-right: 0; }
        .node-number { width: 32px; height: 32px; font-size: 14px; }
        .timeline-line { left: 15px; top: 32px; height: calc(100% + 30px); }
        .node-header { min-height: 0; padding: 14px 16px; flex-direction: column; align-items: flex-start; gap: 12px; }
        .node-title-wrap { gap: 10px; max-width: 100%; }
        .node-badge { min-width: 54px; height: 28px; padding: 0 10px; font-size: 12px; }
        .node-title-text { font-size: 14px; white-space: normal; }
        .result-header { padding: 16px 16px 0 16px; flex-direction: column; align-items: flex-start; gap: 12px; }
        .prompt-flex-box { margin: 16px; padding: 8px 12px; align-items: center; }
        .sample-scene-guide { margin: 16px 16px 0; }
        .icon-btn-round, .icon-btn-submit { width: 36px; height: 36px; }
        .prompt-textarea { font-size: 14px; height: auto; }
        .node-settings { padding: 0 16px 16px 16px; }
        .node-settings > div { flex-direction: column; gap: 20px !important; }
        .config-pane-footer { padding: 12px 16px; justify-content: center; }
        .canvas-wrap { padding: 16px; }
        .preview-canvas-container { max-width: 100%; }
        .modal-box { width: 100vw; height: 100vh; height: 100dvh; border-radius: 0; }
        .studio-logo { font-size: 16px; }
        .studio-top-nav button { padding: 6px 10px; font-size: 13px; }

        .automation-use-warning {
            flex-direction: column;
            align-items: flex-start;
        }
    }

    @media (max-width: 450px) {
        .workspace-footer button {
            width: 100%;
        }
        .config-pane-footer {
            gap: 8px;
            padding: 9px 12px;
        }
    }
}

.image-zoom-overlay { position: fixed; inset: 0; z-index: 10050; display: flex; align-items: center; justify-content: center; padding: 28px; background: rgba(3,10,20,0.82); backdrop-filter: blur(5px); animation: aiImageStudioFadeIn 0.15s ease; }
.image-zoom-dialog { position: relative; max-width: 94vw; max-height: 92vh; display: flex; flex-direction: column; align-items: center; gap: 10px; }
.image-zoom-title { color: #fff; font-size: 14px; font-weight: 800; text-align: center; text-shadow: 0 1px 2px rgba(0,0,0,0.3); }
.image-zoom-image { display: block; max-width: 94vw; max-height: calc(92vh - 38px); object-fit: contain; border-radius: 10px; box-shadow: 0 18px 50px rgba(0,0,0,0.38); background: #fff; }
.image-zoom-close { position: absolute; top: -14px; right: -14px; width: 30px; height: 30px; border: 0; border-radius: 50%; background: #ffffff; color: #0A1A2F; display: flex; align-items: center; justify-content: center; cursor: pointer; box-shadow: 0 4px 14px rgba(0,0,0,0.28); z-index: 2; }
.image-zoom-close:hover { background: #f0fdfe !important; border: 1px solid var(--primary-mint) !important; transform: translateY(-1px); }
.image-zoom-close i { font-size: 18px; }
`;

const DEFAULT_OPTIONS = {
    styles: ['미선택', '사진', '일러스트', '유화'],
    compositions: ['미선택', '정면', '측면', '탑뷰'],
    ratios: ['미선택', '1:1', '4:5', '16:9'],
};

const SAMPLE_RESULTS = [
    "url('https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=900&q=80')",
    "url('https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=900&q=80')",
    "url('https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?auto=format&fit=crop&w=900&q=80')",
];

function createStep(stepNumber, inheritedImage = '', initialPrompt = '', initialImageUrl = '') {
    const isFirst = stepNumber === 1;

    const initialUploadedImage =
        isFirst && initialImageUrl
            ? wrapImageUrl(initialImageUrl)
            : inheritedImage;

    const initialDefaultImageLink =
        isFirst && initialImageUrl
            ? initialImageUrl
            : inheritedImage
                ? unwrapImageUrl(inheritedImage)
                : '';

    return {
        id: Date.now() + Math.random(),
        stepNumber,
        isFirst,
        title: isFirst ? '텍스트로 AI 이미지 제작하기' : '이전 결과물로 AI 이미지 수정하기',

        prompt: isFirst ? initialPrompt : '',
        positive_prompt_text: '',
        negative_prompt_text: '',


        uploadedImage: initialUploadedImage,
        inheritedImage: isFirst ? '' : inheritedImage,

        file: null,
        file_name: isFirst && initialImageUrl ? '추천 이미지' : '',
        defaultImageLink: initialDefaultImageLink,

        style_type_cd: '',
        composition_type_cd: '',
        ratio_cd: '',
        ratio: '',
        width: '',
        height: '',

        history: [],
        historyIndex: 0,
        historyRatioMap: {},

        waitingForPreviousResult: false,
        sourceFromPreviousStep: Boolean(!isFirst && inheritedImage),
        isLoading: false,
    };
}

function wrapImageUrl(imageUrl) {
    if (!imageUrl) return "";
    if (String(imageUrl).startsWith("url(")) return imageUrl;
    return `url('${imageUrl}')`;
}

function unwrapImageUrl(imageUrl) {
    if (!imageUrl) return "";
    return String(imageUrl)
        .replace(/^url\(['"]?/, '')
        .replace(/['"]?\)$/, '');
}

const STUDIO_TUTORIAL_DEMO_EVENT = 'instagram-tutorial:studio-demo-action';

function makeTutorialSampleImage(label, accent = '#00c7cc') {
    const safeLabel = String(label || 'Tutorial sample').replace(/[<>&]/g, '');
    const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="900" height="1125" viewBox="0 0 900 1125">
            <defs>
                <linearGradient id="bg" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0" stop-color="#eefcfc"/>
                    <stop offset="1" stop-color="#d8eef2"/>
                </linearGradient>
            </defs>
            <rect width="900" height="1125" fill="url(#bg)"/>
            <circle cx="680" cy="260" r="190" fill="${accent}" opacity="0.16"/>
            <rect x="250" y="280" width="400" height="500" rx="44" fill="#fff"/>
            <rect x="330" y="405" width="240" height="245" rx="34" fill="${accent}" opacity="0.88"/>
            <rect x="370" y="350" width="160" height="85" rx="20" fill="#16333a"/>
            <text x="450" y="535" text-anchor="middle" font-family="Arial,sans-serif" font-size="42" font-weight="700" fill="#fff">SAMPLE</text>
            <text x="450" y="865" text-anchor="middle" font-family="Arial,sans-serif" font-size="34" font-weight="700" fill="#18363d">${safeLabel}</text>
            <text x="450" y="915" text-anchor="middle" font-family="Arial,sans-serif" font-size="24" fill="#527078">Tutorial preview only</text>
        </svg>`;
    return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
}

export default class AiImageStudioWorkflowClass extends React.Component {
    constructor(props) {
        super(props);

        const firstStep = createStep(
            1,
            '',
            props.initial_prompt || '',
            props.initial_image_url || ''
        );

        this.autoSaveTimer = null;
        this.textareaResizeCleanup = null;
        this.tutorialDemoBackup = null;

        this.state = {
            isModalOpen: false,
            imageZoomUrl: '',
            imageZoomTitle: '',
            activeTopTab: 'studio',
            activeStepId: firstStep.id,
            steps: [firstStep],
            samplePrompt: props.initial_sample_mode ? String(props.initial_sample_prompt || '').trim() : '',
            sampleGuide: props.initial_sample_mode ? {
                title: props.initial_sample_title || '',
                sceneDescription: props.initial_sample_scene_description || '',
                imageGuide: props.initial_sample_image_guide || '샘플 이미지가 적용되어 있습니다.',
                resultExampleUrl: props.initial_sample_result_example_url || '',
                promptPlaceholder: props.initial_sample_prompt_placeholder || '',
            } : null,
            sampleMetaSnapshot: props.initial_sample_mode ? {
                schema_version: 1,
                template_cd: String(props.initial_sample_template_cd || '').trim(),
                ai_image_template_seq: props.initial_sample_ai_image_template_seq || null,
                title: props.initial_sample_title || '',
                scene_description: props.initial_sample_scene_description || '',
                image_guide: props.initial_sample_image_guide || '샘플 이미지가 적용되어 있습니다.',
                reference_image_url: props.initial_sample_reference_image_url || null,
                reference_image_use_yn: props.initial_sample_reference_image_use_yn === 'Y' ? 'Y' : 'N',
            } : null,

            style_type_list: [],
            composition_type_list: [],
            ratio_list: [],

            isApplied: false,
            isApplyingRule: false,
            appliedPrompts: [],
            appliedThumb: '',
            historyItems: ['시즌 룩북 이미지 생성'],
            historyMenuSeq: null,
            historyDeleteDialogOpen: false,
            historyDeleteTarget: null,
            historyRenameDialogOpen: false,
            historyRenameTarget: null,
            historyActionProcessing: false,
            isManuallySaving: false,
            automationUsageList: [],
            duplicateSourceHistoryStepSeq: null,

            selectedFinalStepNo: null,

            aiUsageLoading: false,
            aiUsage: {
                code: 200,
                total_available_nanobanana_call_count: 0,
                total_used_nanobanana_call_count: 0,
                max_available_nanobanana_call_count: 0,
                total_available_gpt_web_search_call_count: 0,
                total_used_gpt_web_search_call_count: 0,
                max_available_gpt_web_search_call_count: 0,
                gpt_web_search_limit_apply_yn: 'N',
                is_api_limit_apply_yn: 'N',
            },

            /* 저장 다이얼로그 */
            save_dialog_show_state: false,
            save_dialog_content: '',
            save_dialog_button_list: [ 
                {
                    title: "확인",
                    type: "1",
                    display_yn:"N",
                }
            ],

            /* 경고 다이얼로그 */
            warning_dialog_show_state: false,
            warning_dialog_content: "",
            warning_dialog_button_list: [{title:"확인", event_method:()=>{this.setState({warning_dialog_show_state:false})}}],
            warning_dialog_width_auto: false,

            isMobileHistoryOpen: false,

            auto_yn : 'N',
            tutorialDemoMode: false,
        };
    }

    componentWillUnmount() {
        window.removeEventListener(STUDIO_TUTORIAL_DEMO_EVENT, this.handleTutorialDemoAction);
        this.tutorialDemoBackup = null;
        if (this.autoSaveTimer) {
            clearTimeout(this.autoSaveTimer);
            this.autoSaveTimer = null;
        }

        if (this.textareaResizeCleanup) {
            this.textareaResizeCleanup();
            this.textareaResizeCleanup = null;
        }
    }

    componentDidMount() {
        window.addEventListener(STUDIO_TUTORIAL_DEMO_EVENT, this.handleTutorialDemoAction);
        this.loadCommonCode(52000);
        this.loadCommonCode(53000);
        this.loadCommonCode(54000);

        this.loadHistoryList();
        this.loadAiUsage();

        if (this.isPopupMode()) {
            this.loadHistoryList();

            if (this.props.initial_history_seq) {
                this.loadHistoryDetail(this.props.initial_history_seq, this.getInitialHistoryOpenOptions());
            }
        }

        setTimeout(() => {
            this.resizeAllTextareas();
        }, 0);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.service_type !== this.props.service_type) {
            this.loadAiUsage();
        }

        if (
            prevProps.initial_history_seq !== this.props.initial_history_seq ||
            prevProps.initial_step_no !== this.props.initial_step_no ||
            prevProps.initial_history_step_seq !== this.props.initial_history_step_seq ||
            prevProps.initial_result_seq !== this.props.initial_result_seq ||
            prevProps.initial_result_no !== this.props.initial_result_no ||
            prevProps.initial_result_image_url !== this.props.initial_result_image_url ||
            prevProps.initial_prompt !== this.props.initial_prompt ||
            prevProps.initial_source_image_url !== this.props.initial_source_image_url ||
            prevProps.initial_ratio !== this.props.initial_ratio ||
            prevProps.initial_ratio_cd !== this.props.initial_ratio_cd ||
            prevProps.initial_style_type_cd !== this.props.initial_style_type_cd ||
            prevProps.initial_composition_type_cd !== this.props.initial_composition_type_cd
        ) {
            if (this.props.initial_history_seq) {
                this.loadHistoryDetail(this.props.initial_history_seq, this.getInitialHistoryOpenOptions());
                return;
            }
        }

        if (
            prevProps.initial_prompt !== this.props.initial_prompt ||
            prevProps.initial_image_url !== this.props.initial_image_url
        ) {
            const initialPrompt = this.props.initial_prompt || "";
            const initialImageUrl = this.props.initial_image_url || "";

            this.setState((prevState) => ({
                steps: prevState.steps.map((step) => {
                    if (step.stepNumber !== 1) return step;

                    return {
                        ...step,
                        prompt: initialPrompt,
                        uploadedImage: initialImageUrl ? wrapImageUrl(initialImageUrl) : '',
                        inheritedImage: '',
                        file: null,
                        file_name: initialImageUrl ? '추천 이미지' : '',
                        defaultImageLink: initialImageUrl || '',
                    };
                }),
            }), () => {
                setTimeout(() => {
                    this.resizeAllTextareas();
                }, 0);
            });
        }
    }

    handleTutorialDemoAction = (event) => {
        const detail = event && event.detail ? event.detail : {};
        if (String(detail.studio || '').toUpperCase() !== 'IMAGE') return;

        const action = String(detail.action || '').toUpperCase();
        if (action === 'RESTORE') {
            this.restoreTutorialDemoState();
            return;
        }

        if (action === 'SHOW_HISTORY') {
            this.showTutorialHistoryState();
            return;
        }

        if (action === 'HIDE_HISTORY') {
            this.hideTutorialHistoryState();
            return;
        }

        if (action === 'SHOW_RESULTS') {
            this.showTutorialDemoImageState('RESULTS');
            return;
        }
        if (action === 'SHOW_STEPS_UP') {
            this.showTutorialDemoImageState('STEPS_UP');
            return;
        }
        if (action === 'SHOW_STEPS_DOWN') {
            this.showTutorialDemoImageState('STEPS_DOWN');
        }
    };

    snapshotTutorialDemoState = () => {
        if (this.tutorialDemoBackup) return;
        this.tutorialDemoBackup = {
            steps: this.state.steps,
            activeStepId: this.state.activeStepId,
            selectedFinalStepNo: this.state.selectedFinalStepNo,
            workflowTitle: this.state.workflowTitle,
            ai_studio_history_seq: this.state.ai_studio_history_seq,
            selectedHistorySeq: this.state.selectedHistorySeq,
            isMobileHistoryOpen: this.state.isMobileHistoryOpen,
            automationUsageList: this.state.automationUsageList,
        };
        if (this.autoSaveTimer) {
            clearTimeout(this.autoSaveTimer);
            this.autoSaveTimer = null;
        }
    };

    showTutorialHistoryState = () => {
        this.snapshotTutorialDemoState();
        if (!this.state.isMobileHistoryOpen) {
            this.setState({ isMobileHistoryOpen: true });
        }
    };

    hideTutorialHistoryState = () => {
        if (this.state.isMobileHistoryOpen) {
            this.setState({ isMobileHistoryOpen: false });
        }
    };

    buildTutorialDemoImageSteps = () => {
        const sample1 = makeTutorialSampleImage('Sample result A', '#00b9c0');
        const sample2 = makeTutorialSampleImage('Sample result B', '#6457d7');
        const sample3 = makeTutorialSampleImage('Sample result C', '#d27b4d');

        const first = createStep(1, '', '제품을 돋보이게 하는 깔끔한 광고 이미지를 만들어줘', '');
        first.history = [wrapImageUrl(sample1), wrapImageUrl(sample2)];
        first.historyIndex = 0;
        first.ratio = '4:5';
        first.run_status = 'DONE';

        const second = createStep(2, wrapImageUrl(sample1));
        second.prompt = '배경을 밝은 스튜디오로 변경해줘';
        second.history = [wrapImageUrl(sample2)];
        second.historyIndex = 0;
        second.ratio = '4:5';
        second.run_status = 'DONE';
        second.defaultImageLink = sample1;

        const third = createStep(3, wrapImageUrl(sample2));
        third.prompt = '제품은 유지하고 카메라 구도만 변경해줘';
        third.history = [wrapImageUrl(sample3)];
        third.historyIndex = 0;
        third.ratio = '4:5';
        third.run_status = 'DONE';
        third.defaultImageLink = sample2;

        return this.normalizeSteps([first, second, third]);
    };

    showTutorialDemoImageState = (mode) => {
        this.snapshotTutorialDemoState();
        const steps = this.buildTutorialDemoImageSteps();
        let visibleSteps = [steps[0]];
        let active = steps[0];

        if (mode === 'STEPS_UP') {
            visibleSteps = steps;
            active = steps[2];
        } else if (mode === 'STEPS_DOWN') {
            visibleSteps = steps;
            active = steps[1];
        }

        this.setState({
            tutorialDemoMode: true,
            steps: visibleSteps,
            activeStepId: active.id,
            selectedFinalStepNo: active.stepNumber,
            workflowTitle: '튜토리얼 예시 작업',
            automationUsageList: [],
        }, () => {
            window.setTimeout(() => this.resizeAllTextareas(), 0);
        });
    };

    restoreTutorialDemoState = () => {
        if (!this.tutorialDemoBackup) {
            if (this.state.tutorialDemoMode) this.setState({ tutorialDemoMode: false });
            return;
        }
        const backup = this.tutorialDemoBackup;
        this.tutorialDemoBackup = null;
        this.setState({
            ...backup,
            tutorialDemoMode: false,
        }, () => {
            window.setTimeout(() => this.resizeAllTextareas(), 0);
        });
    };

    getServiceType = () => {
        const serviceType = this.props.service_type;
        return serviceType && String(serviceType).trim() ? String(serviceType).trim() : '01014';
    };

    loadAiUsage = () => {
        const service_type = this.getServiceType();

        this.setState({
            aiUsageLoading: true,
        });

        http.get('/rest/shop/ai/usage', {
            params: {
                service_type,
            },
        })
        .then((res) => {
            const data = res.data || {};

            this.setState({
                aiUsageLoading: false,
                aiUsage: {
                    code: data.code || 200,
                    total_available_nanobanana_call_count: data.total_available_nanobanana_call_count || 0,
                    total_used_nanobanana_call_count: data.total_used_nanobanana_call_count || 0,
                    max_available_nanobanana_call_count: data.max_available_nanobanana_call_count || 0,
                    total_available_gpt_web_search_call_count: data.total_available_gpt_web_search_call_count || 0,
                    total_used_gpt_web_search_call_count: data.total_used_gpt_web_search_call_count || 0,
                    max_available_gpt_web_search_call_count: data.max_available_gpt_web_search_call_count || 0,
                    gpt_web_search_limit_apply_yn: data.gpt_web_search_limit_apply_yn || 'N',
                    is_api_limit_apply_yn: data.is_api_limit_apply_yn || 'N',
                },
            });
        })
        .catch((e) => {
            console.error('AI 사용량 조회 실패', e);
            this.setState({
                aiUsageLoading: false,
            });
        });
    };

    isPopupMode = () => {
        return this.props.view_mode === "popup";
    };

    getInitialHistoryOpenOptions = () => {
        return {
            step_no: this.props.initial_step_no || '',
            ai_studio_history_step_seq: this.props.initial_history_step_seq || '',
            ai_studio_history_step_result_seq: this.props.initial_result_seq || '',
            result_no: this.props.initial_result_no || '',
            result_image_url: this.props.initial_result_image_url || '',
            initial_prompt: this.props.initial_prompt || '',
            initial_source_image_url: this.props.initial_source_image_url || '',
            initial_ratio: this.props.initial_ratio || '',
            initial_ratio_cd: this.props.initial_ratio_cd || '',
            initial_style_type_cd: this.props.initial_style_type_cd || '',
            initial_composition_type_cd: this.props.initial_composition_type_cd || '',
        };
    };

    isSameValue = (a, b) => {
        if (a === null || a === undefined || a === '' || b === null || b === undefined || b === '') {
            return false;
        }

        return String(a) === String(b);
    };

    getComparableImageUrl = (imageUrl) => {
        if (!imageUrl) return '';

        return String(imageUrl)
            .replace(/^url\(['"]?/, '')
            .replace(/['"]?\)$/, '')
            .split('?')[0]
            .split('#')[0]
            .trim();
    };

    normalizeRatioValue = (ratio) => {
        const value = String(ratio || '').trim();

        if (!value || value === '미선택') {
            return '';
        }

        return value.replace(/\s*:\s*/g, '/').replace(/\s*\/\s*/g, '/');
    };

    findRatioOption = (ratio, ratioCd = '') => {
        const ratioList = this.state.ratio_list || [];

        if (ratioCd) {
            const matchedByCode = ratioList.find((obj) => String(obj.code_cd || '') === String(ratioCd));
            if (matchedByCode) return matchedByCode;
        }

        const normalizedRatio = this.normalizeRatioValue(ratio);
        if (!normalizedRatio) return null;

        return ratioList.find((obj) => {
            return this.normalizeRatioValue(obj.val3 || obj.code_name) === normalizedRatio;
        }) || null;
    };

    getInitialRatioPatch = (options = {}, currentStep = {}) => {
        const initialRatio = options.initial_ratio || options.image_ratio || options.ratio || '';
        const initialRatioCd = options.initial_ratio_cd || options.ratio_cd || '';

        if (!initialRatio && !initialRatioCd) {
            return null;
        }

        const matchedRatioObj = this.findRatioOption(initialRatio, initialRatioCd);
        const sizeValue = matchedRatioObj ? (matchedRatioObj.val1 || '') : '';
        const sizeSplit = sizeValue ? sizeValue.split('*') : [];

        return {
            ratio_cd: matchedRatioObj ? (matchedRatioObj.code_cd || '') : initialRatioCd,
            ratio: matchedRatioObj ? (matchedRatioObj.val3 || initialRatio) : initialRatio,
            width: sizeSplit[0] || currentStep.width || '',
            height: sizeSplit[1] || currentStep.height || '',
        };
    };

    getInitialOptionPatch = (options = {}) => {
        const patch = {};

        if (options.initial_style_type_cd) {
            patch.style_type_cd = options.initial_style_type_cd;
        }

        if (options.initial_composition_type_cd) {
            patch.composition_type_cd = options.initial_composition_type_cd;
        }

        return patch;
    };

    applyInitialRatioToOpenedStep = (options = this.getInitialHistoryOpenOptions()) => {
        const initialRatioPatch = this.getInitialRatioPatch(options);
        const initialOptionPatch = this.getInitialOptionPatch(options);

        if (!initialRatioPatch && Object.keys(initialOptionPatch).length === 0) {
            return;
        }

        this.setState((prevState) => ({
            steps: (prevState.steps || []).map((step) => {
                const isMatchedStep =
                    this.isSameValue(step.ai_studio_history_step_seq, options.ai_studio_history_step_seq)
                    || this.isSameValue(step.stepNumber, options.step_no);

                if (!isMatchedStep) {
                    return step;
                }

                return {
                    ...step,
                    ...initialOptionPatch,
                    ...(this.getInitialRatioPatch(options, step) || {}),
                };
            }),
        }));
    };

    isMatchedInitialStep = (step, options = {}) => {
        if (!step) return false;

        return this.isSameValue(step.ai_studio_history_step_seq, options.ai_studio_history_step_seq)
            || this.isSameValue(step.step_no, options.step_no);
    };

    findMatchedInitialStep = (stepList, options = {}) => {
        return (stepList || []).find((step) => this.isMatchedInitialStep(step, options)) || null;
    };

    findMatchedInitialResultIndex = (resultList, options = {}) => {
        if (!Array.isArray(resultList) || resultList.length === 0) {
            return -1;
        }

        return resultList.findIndex((result) => {
            return this.isSameValue(result.ai_studio_history_step_result_seq, options.ai_studio_history_step_result_seq)
                || this.isSameValue(result.result_no, options.result_no)
                || (
                    this.getComparableImageUrl(options.result_image_url) &&
                    (
                        this.getComparableImageUrl(result.generated_image_url) === this.getComparableImageUrl(options.result_image_url) ||
                        this.getComparableImageUrl(result.generated_thumbnail_url) === this.getComparableImageUrl(options.result_image_url)
                    )
                );
        });
    };

    loadHistoryList = (auto_yn = "N") => {
        return http.get('/rest/shop/aiStudio/historyList?auto_yn=' + auto_yn)
            .then((res) => {
                if (res.data && res.data.result === 'success') {
                    const historyItems = res.data.history_list || [];
                    this.setState({ historyItems });
                    return historyItems;
                }
                return [];
            })
            .catch((e) => {
                console.error('히스토리 목록 조회 실패', e);
                return [];
            });
    };

    toggleHistoryMenu = (event, historyItem) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        const historySeq = historyItem && historyItem.ai_studio_history_seq;
        this.setState((prevState) => ({
            historyMenuSeq:
                String(prevState.historyMenuSeq || '') === String(historySeq || '')
                    ? null
                    : historySeq,
        }));
    };

    handleHistoryItemClick = (historyItem) => {
        if (!historyItem || this.state.historyActionProcessing) return;

        this.setState({ historyMenuSeq: null }, () => {
            this.loadHistoryDetail(historyItem.ai_studio_history_seq);
        });
    };

    handleHistoryRename = (event, historyItem) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!historyItem || this.state.historyActionProcessing) return;

        this.setState({
            historyMenuSeq: null,
            historyRenameDialogOpen: true,
            historyRenameTarget: historyItem,
        });
    };

    closeHistoryRenameDialog = () => {
        if (this.state.historyActionProcessing) return;

        this.setState({
            historyRenameDialogOpen: false,
            historyRenameTarget: null,
        });
    };

    confirmHistoryRename = async (inputValues = []) => {
        const historyItem = this.state.historyRenameTarget;
        const currentTitle = String(historyItem?.history_title || '새 작업').trim();
        const normalizedTitle = String(inputValues[0] || '').trim();

        if (!historyItem) {
            this.closeHistoryRenameDialog();
            return;
        }

        if (!normalizedTitle) {
            this.setState({
                warning_dialog_show_state: true,
                warning_dialog_content: '변경할 히스토리 이름을 입력해주세요.',
                warning_dialog_button_list: [{
                    title: '확인',
                    event_method: () => this.setState({ warning_dialog_show_state: false }),
                }],
            });
            return;
        }

        this.setState({
            historyRenameDialogOpen: false,
            historyRenameTarget: null,
        });

        if (normalizedTitle === currentTitle) return;
        await this.renameHistory(historyItem, normalizedTitle);
    };

    renameHistory = async (historyItem, historyTitle) => {
        const historySeq = historyItem && historyItem.ai_studio_history_seq;
        const normalizedTitle = String(historyTitle || '').trim();
        if (!historySeq || !normalizedTitle || this.state.historyActionProcessing) return;

        this.setState({
            historyActionProcessing: true,
            save_dialog_show_state: true,
            save_dialog_content: '이름 변경 중입니다.',
            save_dialog_button_list: [{ title: '확인', type: '1', display_yn: 'N' }],
        });

        try {
            const response = await http.put('/rest/shop/aiStudio/history/title', {
                ai_studio_history_seq: historySeq,
                history_title: normalizedTitle,
            });
            const data = response && response.data ? response.data : {};

            if (data.result !== 'success' && data.status !== 'success') {
                throw new Error(data.message || '히스토리 이름 변경에 실패했습니다.');
            }

            await this.loadHistoryList(this.state.auto_yn);

            this.setState((prevState) => ({
                workflowTitle:
                    String(prevState.selectedHistorySeq || '') === String(historySeq)
                        ? normalizedTitle
                        : prevState.workflowTitle,
                historyActionProcessing: false,
                save_dialog_show_state: true,
                save_dialog_content: '이름 변경이 완료되었습니다.',
                save_dialog_button_list: [{
                    title: '확인',
                    type: '1',
                    display_yn: 'Y',
                    event_method: () => this.setState({ save_dialog_show_state: false }),
                }],
            }));
        } catch (error) {
            console.error('AI 스튜디오 히스토리 이름 변경 실패:', error);
            const message = error?.response?.data?.message || error?.message || '히스토리 이름을 변경하지 못했습니다.';

            this.setState({
                historyActionProcessing: false,
                save_dialog_show_state: false,
                warning_dialog_show_state: true,
                warning_dialog_content: message,
                warning_dialog_button_list: [{
                    title: '확인',
                    event_method: () => this.setState({ warning_dialog_show_state: false }),
                }],
            });
        }
    };

    handleHistoryDuplicate = async (event, historyItem) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        const historySeq = historyItem && historyItem.ai_studio_history_seq;
        if (!historySeq || this.state.historyActionProcessing) return;

        this.setState({
            historyMenuSeq: null,
            historyActionProcessing: true,
            save_dialog_show_state: true,
            save_dialog_content: '새 작업으로 복제 중입니다.',
            save_dialog_button_list: [{ title: '확인', type: '1', display_yn: 'N' }],
        });

        try {
            const isCurrentDisplayedHistory =
                String(this.state.ai_studio_history_seq || '') === String(historySeq || '');
            const duplicateSourceHistoryStepSeq = isCurrentDisplayedHistory
                ? this.state.duplicateSourceHistoryStepSeq
                : null;
            const duplicateRequestConfig = duplicateSourceHistoryStepSeq
                ? {
                    params: {
                        source_history_step_seq: duplicateSourceHistoryStepSeq,
                    },
                }
                : undefined;

            const response = await http.post(
                `/rest/shop/aiStudio/history/${encodeURIComponent(historySeq)}/duplicate`,
                null,
                duplicateRequestConfig
            );
            const data = response && response.data ? response.data : {};
            if (data.result !== 'success' && data.status !== 'success') {
                throw new Error(data.message || '새 작업 복제에 실패했습니다.');
            }

            const newHistorySeq = data.ai_studio_history_seq;
            await this.loadHistoryList(this.state.auto_yn);
            await this.loadHistoryDetail(newHistorySeq);

            this.setState({
                historyActionProcessing: false,
                save_dialog_show_state: true,
                save_dialog_content: '새 작업으로 복제되었습니다.',
                save_dialog_button_list: [{
                    title: '확인',
                    type: '1',
                    display_yn: 'Y',
                    event_method: () => this.setState({ save_dialog_show_state: false }),
                }],
            });
        } catch (error) {
            console.error('AI 스튜디오 새 작업 복제 실패:', error);
            this.setState({
                historyActionProcessing: false,
                save_dialog_show_state: false,
                warning_dialog_show_state: true,
                warning_dialog_content: error?.response?.data?.message || error?.message || '새 작업으로 복제하지 못했습니다.',
                warning_dialog_button_list: [{
                    title: '확인',
                    event_method: () => this.setState({ warning_dialog_show_state: false }),
                }],
            });
        }
    };

    handleHistoryDelete = (event, historyItem) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!historyItem || this.state.historyActionProcessing) return;

        this.setState({
            historyMenuSeq: null,
            historyDeleteDialogOpen: true,
            historyDeleteTarget: historyItem,
        });
    };

    closeHistoryDeleteDialog = () => {
        if (this.state.historyActionProcessing) return;

        this.setState({
            historyDeleteDialogOpen: false,
            historyDeleteTarget: null,
        });
    };

    deleteHistory = async () => {
        const historyItem = this.state.historyDeleteTarget;
        const historySeq = historyItem && historyItem.ai_studio_history_seq;
        if (!historySeq || this.state.historyActionProcessing) return;

        const deletingSelectedHistory =
            String(this.state.selectedHistorySeq || '') === String(historySeq);
        const historyAutoYn = this.state.auto_yn || 'N';

        this.setState({
            historyActionProcessing: true,
            historyDeleteDialogOpen: false,
            save_dialog_show_state: true,
            save_dialog_content: '삭제 중입니다.',
            save_dialog_button_list: [{ title: '확인', type: '1', display_yn: 'N' }],
        });

        try {
            const response = await http.delete(
                `/rest/shop/aiStudio/history/${encodeURIComponent(historySeq)}`
            );
            const data = response && response.data ? response.data : {};
            const resultStatus = String(data.result || data.status || '').toLowerCase();

            if (resultStatus === 'used') {
                this.setState({
                    historyActionProcessing: false,
                    historyDeleteTarget: null,
                    save_dialog_show_state: false,
                    warning_dialog_show_state: true,
                    warning_dialog_content:
                        '\'AI 콘텐츠 자동등록\' 설정에 사용 중인 히스토리는 삭제할 수 없습니다.<br/>' +
                        '\'AI 콘텐츠 자동등록\' 설정에서 다른 AI 이미지 생성 규칙으로 변경한 후 다시 시도해주세요.',
                    warning_dialog_width_auto: true,    
                    warning_dialog_button_list: [{
                        title: '확인',
                        event_method: () => this.setState({ warning_dialog_show_state: false, warning_dialog_width_auto: false }),
                    }],
                });
                return;
            }

            if (resultStatus !== 'success') {
                throw new Error(data.message || '히스토리 삭제에 실패했습니다.');
            }

            const remainingHistoryItems = await this.loadHistoryList(historyAutoYn);

            if (deletingSelectedHistory) {
                if (remainingHistoryItems.length > 0) {
                    await this.loadHistoryDetail(remainingHistoryItems[0].ai_studio_history_seq);
                } else {
                    this.startNewWorkflow();
                }
            }

            this.setState({
                historyActionProcessing: false,
                historyDeleteTarget: null,
                save_dialog_show_state: true,
                save_dialog_content: '삭제가 완료되었습니다.',
                save_dialog_button_list: [{
                    title: '확인',
                    type: '1',
                    display_yn: 'Y',
                    event_method: () => this.setState({ save_dialog_show_state: false }),
                }],
            });
        } catch (error) {
            console.error('AI 스튜디오 히스토리 삭제 실패:', error);
            const message = error?.response?.data?.message || error?.message || '히스토리를 삭제하지 못했습니다.';

            this.setState({
                historyActionProcessing: false,
                historyDeleteTarget: null,
                save_dialog_show_state: false,
                warning_dialog_show_state: true,
                warning_dialog_content: message,
                warning_dialog_button_list: [{
                    title: '확인',
                    event_method: () => this.setState({ warning_dialog_show_state: false }),
                }],
            });
        }
    };

    getAutomationHistoryUsageRequestParams = (aiStudioHistorySeq) => {
        const params = { ai_studio_history_seq: aiStudioHistorySeq };
        const settingSeq = this.props.automation_setting_seq;
        const slideNo = this.props.automation_slide_no;
        const historySeq = this.props.automation_history_seq;

        if (settingSeq && slideNo) {
            params.automation_setting_seq = settingSeq;
            params.automation_slide_no = slideNo;
            if (historySeq) {
                params.automation_history_seq = historySeq;
            }
        }

        return params;
    };

    getLocalAutomationUsageList = () => {
        const targetHistorySeq = String(this.state.ai_studio_history_seq || '').trim();
        const currentSlideNo = Number(this.props.automation_slide_no || 0);
        const localUsageList = Array.isArray(this.props.automation_local_usage_list)
            ? this.props.automation_local_usage_list
            : [];

        if (!targetHistorySeq) return [];

        return localUsageList.filter((usage) => {
            const historySeq = String(usage?.ai_studio_history_seq || '').trim();
            const slideNo = Number(usage?.slide_no || 0);
            return historySeq === targetHistorySeq && slideNo !== currentSlideNo;
        });
    };

    isCurrentHistoryAutomationProtected = () => {
        const serverUsageList = Array.isArray(this.state.automationUsageList)
            ? this.state.automationUsageList
            : [];
        return serverUsageList.length > 0 || this.getLocalAutomationUsageList().length > 0;
    };

    isCurrentHistoryEditBlocked = () => {
        return this.isCurrentHistoryAutomationProtected() && !this.isPopupMode();
    };

    parseStarterMetaSnapshot = (rawMeta) => {
        if (!rawMeta) return null;
        if (typeof rawMeta === 'object') return rawMeta;
        try {
            const parsed = JSON.parse(String(rawMeta));
            return parsed && typeof parsed === 'object' ? parsed : null;
        } catch (e) {
            console.warn('Starter 샘플 메타데이터 파싱 실패', e);
            return null;
        }
    };

    // AI 자동 세팅 기록과 사용자가 직접 작성한 샘플 기록을 구분한다.
    // 과거 자동 세팅의 템플릿 기록에는 image_type_codes와 original_image_prompt가 함께 저장되어 있다.
    isAutoSetupPromptHistory = (meta) => Boolean(meta && (
        String(meta.prompt_origin || '').toUpperCase() === 'AUTO_SETUP' ||
        (Object.prototype.hasOwnProperty.call(meta, 'image_type_codes') &&
         Object.prototype.hasOwnProperty.call(meta, 'original_image_prompt'))
    ));

    buildStarterMetaSnapshot = () => {
        const guide = this.state.sampleGuide || {};
        const stored = this.state.sampleMetaSnapshot || {};
        // 비샘플 자동 세팅의 메타데이터는 사용자 입력 출처만 보존한다.
        // 자유 생성 기록에 샘플용 템플릿 정보를 새로 채우지 않는다.
        if (this.isAutoSetupPromptHistory(stored) && !String(this.state.samplePrompt || '').trim()) {
            return { ...stored };
        }
        const firstStep = (this.state.steps || []).find((step) => step.stepNumber === 1);
        const hasOriginalImagePrompt = Object.prototype.hasOwnProperty.call(
            stored,
            'original_image_prompt'
        );
        // 과거 기록에 없는 원본 프롬프트를 현재 편집값으로 추정하지 않는다.
        const isNewHistory = !this.state.ai_studio_history_seq;

        return {
            ...stored,
            schema_version: stored.schema_version || 1,
            // 최초 생성 시 constructor에서 저장한 식별자만 사용한다.
            // 다른 히스토리를 열었을 때 최초 진입 props로 오염시키지 않는다.
            template_cd: String(stored.template_cd || '').trim(),
            ai_image_template_seq: stored.ai_image_template_seq || null,
            reference_image_url: Object.prototype.hasOwnProperty.call(stored, 'reference_image_url')
                ? stored.reference_image_url : null,
            reference_image_use_yn: stored.reference_image_use_yn === 'Y' ? 'Y' : 'N',
            title: guide.title || stored.title || stored.template_title || '',
            scene_description: guide.sceneDescription || stored.scene_description || '',
            image_guide: guide.imageGuide || stored.image_guide || '',
            prompt_placeholder:
                guide.promptPlaceholder
                || stored.prompt_placeholder
                || stored.promptPlaceholder
                || '',
            // 최초 생성 때만 원본 사용자 입력을 기록한다. 이후에는 저장된 값만 유지한다.
            ...(hasOriginalImagePrompt
                ? { original_image_prompt: String(stored.original_image_prompt || '') }
                : isNewHistory
                    ? { original_image_prompt: firstStep ? String(firstStep.prompt || '') : '' }
                    : {}),
        };
    };

    // 템플릿 선택 정보는 히스토리 메타에 보존한다.
    // 이름/프롬프트 유사도로 템플릿을 추정하면 다른 폰트를 잘못 적용할 수 있으므로 사용하지 않는다.
    getSelectedTemplateReference = () => {
        const meta = this.state.sampleMetaSnapshot || {};
        // 히스토리를 전환한 뒤에는 최초 진입 props를 재사용하지 않는다.
        const templateCd = String(meta.template_cd || '').trim();
        const templateSeqRaw = meta.ai_image_template_seq;
        const templateSeq = templateSeqRaw === null || templateSeqRaw === undefined ||
            String(templateSeqRaw).trim() === '' ? null : Number(templateSeqRaw);

        return {
            template_cd: templateCd,
            ai_image_template_seq: Number.isSafeInteger(templateSeq) && templateSeq > 0
                ? templateSeq
                : null,
        };
    };

    // 과거 히스토리는 프런트 캐시의 레퍼런스 URL이 아닌,
    // 서버가 history_seq -> starter_meta_snapshot_json -> template_cd -> 현재 DB를 조회하도록 한다.
    getGenerationTemplateRequest = () => {
        const reference = this.getSelectedTemplateReference();
        // 일반 이미지 생성에서는 기존 API 파라미터를 변경하지 않는다.
        if (!reference.template_cd && !reference.ai_image_template_seq) return {};
        const historySeq = this.state.ai_studio_history_seq;
        if (historySeq && String(historySeq).trim()) {
            return { ai_studio_history_seq: historySeq };
        }
        return {
            ...(reference.template_cd ? { template_cd: reference.template_cd } : {}),
            ...(!reference.template_cd && reference.ai_image_template_seq
                ? { ai_image_template_seq: reference.ai_image_template_seq }
                : {}),
        };
    };

    loadHistoryDetail = (ai_studio_history_seq, options = {}) => {
        return http.get('/rest/shop/aiStudio/historyDetail', {
            params: this.getAutomationHistoryUsageRequestParams(ai_studio_history_seq)
        })
        .then((res) => {
            if (res.data && res.data.result === 'success') {
                const historyInfo = res.data.history_info || {};
                const stepList = res.data.step_list || [];
                const automationUsageList = Array.isArray(res.data.automation_usage_list)
                    ? res.data.automation_usage_list
                    : [];
                const openOptions = options || {};
                const convertedSteps = this.convertHistoryStepListToStateSteps(stepList, openOptions);

                const initialSelectedStep = this.findMatchedInitialStep(stepList, openOptions);
                const duplicateSourceHistoryStepSeq =
                    initialSelectedStep && openOptions.ai_studio_history_step_seq
                        ? openOptions.ai_studio_history_step_seq
                        : null;
                const selectedFinalStep = initialSelectedStep || stepList.find((item) => item.is_final_selected === 'Y');
                const activeStep =
                    selectedFinalStep
                        ? convertedSteps.find((step) => step.stepNumber === selectedFinalStep.step_no)
                        : (convertedSteps[0] || null);

                const starterSampleYn = String(historyInfo.starter_sample_yn || 'N').toUpperCase() === 'Y';
                const historyMeta = this.parseStarterMetaSnapshot(historyInfo.starter_meta_snapshot_json);
                const starterMeta = starterSampleYn ? historyMeta : null;
                // 신규 및 과거 기록 모두 DB의 STEP_CURRENT.prompt_text를 그대로 표시한다.
                // 과거 메타데이터의 original_image_prompt로 사용자 입력값을 덮어쓰지 않는다.

                this.setState({
                    ai_studio_history_seq: historyInfo.ai_studio_history_seq,
                    workflowTitle: historyInfo.history_title || '',
                    selectedHistorySeq: historyInfo.ai_studio_history_seq,
                    automationUsageList,
                    duplicateSourceHistoryStepSeq,
                    // 기본 템플릿 프롬프트는 실행용으로만 유지하고 화면에는 노출하지 않는다.
                    samplePrompt: starterSampleYn ? String(historyInfo.starter_prompt_snapshot || '').trim() : '',
                    sampleGuide: starterSampleYn ? {
                        title: (starterMeta && starterMeta.title) || historyInfo.history_title || '',
                        sceneDescription: (starterMeta && (starterMeta.scene_description || starterMeta.sceneDescription)) || '',
                        imageGuide: (starterMeta && (starterMeta.image_guide || starterMeta.imageGuide)) || '',
                        resultExampleUrl: historyInfo.starter_result_example_url || '',
                        promptPlaceholder:
                            (starterMeta && (
                                starterMeta.prompt_placeholder ||
                                starterMeta.promptPlaceholder
                            )) || '',
                    } : null,
                    sampleMetaSnapshot: starterSampleYn || this.isAutoSetupPromptHistory(historyMeta)
                        ? historyMeta : null,
                    steps: convertedSteps,
                    activeStepId: activeStep ? activeStep.id : null,
                    selectedFinalStepNo: selectedFinalStep
                        ? selectedFinalStep.step_no
                        : (stepList.length > 0 ? stepList[stepList.length - 1].step_no : null)
                }, async () => {
                    await this.ensureVisiblePreviewRatios(
                        convertedSteps.map((step) => step.id)
                    );

                    setTimeout(() => {
                        this.resizeAllTextareas();

                        // 히스토리 상세 로드 후, 선택된 단계가 보이도록 스크롤 이동
                        const selectedElement = document.querySelector('.step-node.active');
                        if (selectedElement) {
                            selectedElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        }

                        // 히스토리 상세를 불러온 뒤 모바일이면 닫히게 처리
                        this.closeMobileHistory();
                    }, 0);
                });
            }
        })
        .catch((e) => {
            console.error('히스토리 상세 조회 실패', e);
        });
    };

    convertHistoryStepListToStateSteps = (stepList, options = {}) => {
        return (stepList || []).map((item, index) => {
            const initialSourceImageUrl = this.isMatchedInitialStep(item, options) && options.initial_source_image_url
                ? options.initial_source_image_url
                : (item.source_image_url || '');
            const sourceImage = initialSourceImageUrl
                ? `url('${initialSourceImageUrl}')`
                : '';

            const rawResultImageList = item.result_image_list || [];
            const validResultImageList = rawResultImageList.filter((result) => result.generated_image_url);
            const resultImageList = validResultImageList
                .map((result) => result.generated_image_url ? `url('${result.generated_image_url}')` : '')
                .filter(Boolean);

            const selectedIndex = validResultImageList.findIndex(
                (result) => result.is_selected_yn === 'Y'
            );
            const matchedInitialResultIndex = this.isMatchedInitialStep(item, options)
                ? this.findMatchedInitialResultIndex(validResultImageList, options)
                : -1;

            const fallbackGeneratedImage = item.generated_image_url
                ? `url('${item.generated_image_url}')`
                : '';

            const finalHistory = resultImageList.length > 0
                ? resultImageList
                : (fallbackGeneratedImage ? [fallbackGeneratedImage] : []);

            const previousStep = index > 0 ? (stepList[index - 1] || null) : null;
            const previousGeneratedUrls = new Set();
            if (previousStep) {
                const addPreviousUrl = (value) => {
                    const normalized = this.getComparableImageUrl(value);
                    if (normalized) previousGeneratedUrls.add(normalized);
                };

                addPreviousUrl(previousStep.generated_image_url);
                addPreviousUrl(previousStep.generated_thumbnail_url);
                (previousStep.result_image_list || []).forEach((result) => {
                    addPreviousUrl(result.generated_image_url);
                    addPreviousUrl(result.generated_thumbnail_url);
                });
            }

            const normalizedSourceImageUrl = this.getComparableImageUrl(initialSourceImageUrl);
            const sourceFromPreviousStep = Boolean(
                item.step_no > 1 &&
                normalizedSourceImageUrl &&
                previousGeneratedUrls.has(normalizedSourceImageUrl)
            );
            const waitingForPreviousResult = Boolean(
                item.step_no > 1 &&
                !initialSourceImageUrl &&
                finalHistory.length === 0
            );

            const safeHistoryIndex =
                matchedInitialResultIndex > -1
                    ? matchedInitialResultIndex
                    : selectedIndex > -1
                    ? selectedIndex
                    : (finalHistory.length > 0 ? finalHistory.length - 1 : 0);

            const matchedRatioObj = (this.state.ratio_list || []).find(
                (obj) => obj.code_cd === item.ratio_cd
            );

            const initialRatioPatch = this.isMatchedInitialStep(item, options)
                ? this.getInitialRatioPatch(options, {
                    ratio_cd: item.ratio_cd || '',
                    ratio: item.ratio || '',
                    width: item.width || '',
                    height: item.height || '',
                })
                : null;
            const initialOptionPatch = this.isMatchedInitialStep(item, options)
                ? this.getInitialOptionPatch(options)
                : {};

            const ratioValue = initialRatioPatch
                ? initialRatioPatch.ratio
                : (matchedRatioObj ? (matchedRatioObj.val3 || '') : (item.ratio || ''));
            const sizeValue = matchedRatioObj ? (matchedRatioObj.val1 || '') : '';
            const sizeSplit = sizeValue ? sizeValue.split('*') : [];

            return {
                id: `history_step_${item.ai_studio_history_step_seq}`,
                ai_studio_history_step_seq: item.ai_studio_history_step_seq,
                stepNumber: item.step_no,
                isFirst: item.step_no === 1,
                title: item.step_no === 1
                    ? '텍스트로 AI 이미지 제작하기'
                    : '이전 결과물로 AI 이미지 수정하기',
                prompt: this.isMatchedInitialStep(item, options) && options.initial_prompt
                    ? options.initial_prompt
                    : (item.prompt_text || ''),
                positive_prompt_text: item.positive_prompt_text || '',
                negative_prompt_text: item.negative_prompt_text || '',
                uploadedImage: sourceImage,
                inheritedImage: item.step_no > 1 ? sourceImage : '',
                file: null,
                file_name: '',
                defaultImageLink: initialSourceImageUrl,
                style_type_cd: initialOptionPatch.style_type_cd || item.style_type_cd || '',
                composition_type_cd: initialOptionPatch.composition_type_cd || item.camera_angle_cd || '',
                ratio_cd: initialRatioPatch ? (initialRatioPatch.ratio_cd || '') : (item.ratio_cd || ''),
                ratio: ratioValue,
                width: initialRatioPatch ? (initialRatioPatch.width || '') : (item.width || sizeSplit[0] || ''),
                height: initialRatioPatch ? (initialRatioPatch.height || '') : (item.height || sizeSplit[1] || ''),
                history: finalHistory,
                historyIndex: safeHistoryIndex,
                result_image_list: validResultImageList,
                historyRatioMap: {},
                waitingForPreviousResult,
                sourceFromPreviousStep: sourceFromPreviousStep || waitingForPreviousResult,
                isLoading: false,
                run_status: item.run_status || 'READY',
                is_final_selected: item.is_final_selected || 'N',
            };
        });
    };

    loadCommonCode = (upper_code_cd) => {
        http.get('/rest/common/cafe24Code?upper_code_cd=' + upper_code_cd + is_test_use)
            .then((res) => {
                if (res.data && Array.isArray(res.data) && res.data.length > 0) {
                    let unselectedOption = {
                        code_cd: '',
                        code_name: '미선택',
                        val1: '',
                        val2: '',
                        val3: '',
                    };

                    if (upper_code_cd === 54000) {
                        unselectedOption = {
                            code_cd: '',
                            code_name: '미선택',
                            val1: '',
                            val2: '',
                            val3: '미선택',
                        };
                    }

                    this.setState({
                        [stability_prompt[upper_code_cd]]: [unselectedOption, ...res.data],
                    }, () => {
                        if (upper_code_cd === 54000 && this.props.initial_history_seq) {
                            this.applyInitialRatioToOpenedStep();
                        }
                    });
                }
            })
            .catch((e) => {
                console.error('공통코드 조회 실패', upper_code_cd, e);
            });
    };

    setType = (stepId, type, name) => {
        this.updateStep(stepId, {
            [name]: type.code_cd,
            positive_prompt_text: '',
        });
    };

    setTypeRatio = (stepId, type) => {
        const ratioValue = type?.val3 || '';
        const sizeValue = type?.val1 || '';
        const sizeSplit = sizeValue ? sizeValue.split('*') : [];
        const width = sizeSplit[0] || '';
        const height = sizeSplit[1] || '';

        this.updateStep(stepId, {
            ratio_cd: type?.code_cd || '',
            ratio: ratioValue,
            width,
            height,
        });
    };

    getActiveStep = () => {
        const { steps, activeStepId } = this.state;
        return steps.find((step) => step.id === activeStepId) || steps[0] || null;
    };

    // openModal = () => {
    //     if (this.isPopupMode()) {
    //         this.loadHistoryList();
    //         return;
    //     }

    //     this.setState({ isModalOpen: true }, () => {
    //         this.loadHistoryList();
    //     });
    // };

    openModal = () => {
        this.loadHistoryList();

        if (this.isPopupMode()) {
            return;
        }

        this.setState({ isModalOpen: true });
    };

    // closeModal = () => {
    //     if (this.isPopupMode()) {
    //         if (this.props.onClose) {
    //             this.props.onClose();
    //         }
    //         return;
    //     }

    //     this.setState({ isModalOpen: false });
    // };

    closeModal = () => {
        if (this.isPopupMode()) {
            if (this.props.onClose) {
                this.props.onClose();
            }
            return;
        }

        if (!this.isPopupMode()) {
            return;
        }

        this.setState({ isModalOpen: false });
    };

    openImageZoom = (imageUrl, title = '', event = null) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        const normalizedUrl = this.extractRawUrl(imageUrl);
        if (!normalizedUrl) return;
        this.setState({
            imageZoomUrl: normalizedUrl,
            imageZoomTitle: title || '',
        });
    };

    closeImageZoom = (event = null) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        this.setState({
            imageZoomUrl: '',
            imageZoomTitle: '',
        });
    };

    focusStep = (stepId) => {
        const step = this.state.steps.find((item) => item.id === stepId);

        this.setState({
            activeStepId: stepId,
            selectedFinalStepNo: step ? step.stepNumber : null,
        }, () => {
            this.scheduleAutoSave(600);
        });
    };

    startNewWorkflow = () => {
        const firstStep = createStep(1, '', '', '');

        this.setState({
            activeTopTab: 'studio',
            activeStepId: firstStep.id,
            steps: [firstStep],
            samplePrompt: '',
            sampleGuide: null,
            sampleMetaSnapshot: null,

            ai_studio_history_seq: null,
            selectedHistorySeq: null,
            workflowTitle: '',
            selectedFinalStepNo: null,
            isMobileHistoryOpen: false,
            historyMenuSeq: null,
            historyDeleteDialogOpen: false,
            historyDeleteTarget: null,
            automationUsageList: [],
            duplicateSourceHistoryStepSeq: null,
        }, () => {
            setTimeout(() => {
                this.resizeAllTextareas();
            }, 0);
        });
    };

    updateStep = (stepId, patch) => {
        this.setState((prevState) => ({
            steps: prevState.steps.map((step) =>
                step.id === stepId
                    ? { ...step, ...(typeof patch === 'function' ? patch(step) : patch) }
                    : step
            ),
        }));
    };

    handlePromptChange = (stepId, event) => {
        const value = event.target.value;
        const textarea = event.target;

        this.applyTextareaLayout(textarea);

        this.updateStep(stepId, { prompt: value, positive_prompt_text: '' });
    };

    handleTextareaResizeStart = (event) => {
        const textarea = event.currentTarget;
        if (!textarea) return;

        if (this.textareaResizeCleanup) {
            this.textareaResizeCleanup();
            this.textareaResizeCleanup = null;
        }

        const startHeight = textarea.getBoundingClientRect().height;

        const finishResize = () => {
            if (this.textareaResizeCleanup) {
                this.textareaResizeCleanup();
                this.textareaResizeCleanup = null;
            }

            window.requestAnimationFrame(() => {
                if (!textarea.isConnected) return;

                const resizedHeight = textarea.getBoundingClientRect().height;

                // 실제 높이가 바뀐 경우에만 사용자가 직접 조절한 높이로 기억한다.
                if (Math.abs(resizedHeight - startHeight) > 1) {
                    textarea.dataset.manualHeight = String(resizedHeight);
                    textarea.style.height = resizedHeight + 'px';
                    textarea.style.overflowY = textarea.scrollHeight > resizedHeight ? 'auto' : 'hidden';
                }
            });
        };

        const cleanup = () => {
            window.removeEventListener('pointerup', finishResize, true);
            window.removeEventListener('pointercancel', finishResize, true);
        };

        this.textareaResizeCleanup = cleanup;
        window.addEventListener('pointerup', finishResize, true);
        window.addEventListener('pointercancel', finishResize, true);
    };

    triggerFileInput = (stepId) => {
        const step = this.state.steps.find((item) => item.id === stepId);
        if (!step || !step.isFirst) return;

        const fileInput = document.getElementById(`fileInput_${stepId}`);
        if (fileInput) {
            fileInput.click();
        }
    };

    handleStepUpload = (stepId, event) => {
        const step = this.state.steps.find((item) => item.id === stepId);
        if (!step || !step.isFirst) {
            if (event && event.target) event.target.value = '';
            return;
        }

        const file = event.target.files && event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (e) => {
            const result = e.target && e.target.result ? `url('${e.target.result}')` : '';
            this.updateStep(stepId, {
                uploadedImage: result,
                inheritedImage: '',
                file: file,
                file_name: file.name,
                defaultImageLink: '',
                waitingForPreviousResult: false,
                sourceFromPreviousStep: false,
            });
        };
        reader.readAsDataURL(file);
    };

    removeUploadedImage = (stepId, event) => {
        if (event) event.stopPropagation();

        this.setState((prevState) => ({
            steps: prevState.steps.map((step) => {
                if (step.id !== stepId) return step;

                if (!step.isFirst) {
                    return {
                        ...step,
                        uploadedImage: step.inheritedImage || '',
                        file: null,
                        file_name: '',
                        defaultImageLink: step.inheritedImage
                            ? this.extractUrl(step.inheritedImage)
                            : '',
                    };
                }

                return {
                    ...step,
                    uploadedImage: '',
                    inheritedImage: '',
                    file: null,
                    file_name: '',
                    defaultImageLink: '',
                };
            }),
        }));
    };

    selectOption = (stepId, key, value) => {
        this.updateStep(stepId, { [key]: value, positive_prompt_text: '' });
    };

    generateNode = async (stepNumber, stepId, event, options = {}) => {
        if (this.isCurrentHistoryEditBlocked()) {
            if (event) event.stopPropagation();
            return {
                success: false,
                errorType: 'AUTOMATION_HISTORY_IN_USE',
                message: '자동화에서 사용 중인 작업은 새 작업으로 복제한 후 수정할 수 있습니다.'
            };
        }

        if (this.state.tutorialDemoMode) {
            if (event) event.stopPropagation();
            return { success: false, tutorialDemo: true };
        }
        const {
            skipFirstStepAutoSave = false,
            suppressWarningDialog = false,
        } = options;

        if (event) event.stopPropagation();

        const step = this.state.steps.find((item) => item.id === stepId);
        if (!step) {
            return {
                success: false,
                errorType: 'STEP_NOT_FOUND',
                message: stepNumber + '단계를 찾을 수 없습니다.'
            };
        }

        // 원본 문구의 대괄호와 콜론은 이미지 생성 요청에도 그대로 전달한다.
        const userPrompt = String(step.prompt || '');
        const starterPrompt = step.isFirst ? String(this.state.samplePrompt || '').trim() : '';
        const prompt = starterPrompt
            ? starterPrompt + (userPrompt.trim() ? `

사용자 추가 요청:
${userPrompt.trim()}` : '')
            : userPrompt;

        if (StringUtil.checkEmptyString(prompt)) {
            if (!suppressWarningDialog) {
                this.setState({
                    warning_dialog_show_state: true,
                    warning_dialog_content: stepNumber+"단계에 입력하신 내용이 없습니다.<br/>생성할 이미지에 대한 설명을 입력해 주세요.",
                    warning_dialog_button_list: [
                        {
                            title: "확인",
                            event_method: () => {
                                this.setState({ warning_dialog_show_state: false });
                            }
                        }
                    ]
                });
            }

            this.updateStep(stepId, { prompt: userPrompt });

            return {
                success: false,
                errorType: 'EMPTY_PROMPT',
                message: stepNumber + '단계에 입력하신 내용이 없습니다.<br/>생성할 이미지에 대한 설명을 입력해 주세요.'
            };
        }

        const matchedRatioObj = (this.state.ratio_list || []).find(
            (obj) => obj.code_cd === step.ratio_cd
        );

        const effectiveRatio =
            !step.ratio || step.ratio === '미선택'
                ? ''
                : step.ratio;

        const defaultImageLink =
            step.defaultImageLink
                ? step.defaultImageLink
                : (step.inheritedImage
                    ? step.inheritedImage.replace(/^url\(['"]?/, '').replace(/['"]?\)$/, '')
                    : '');

        const hasSourceImage = !!(step.file || defaultImageLink);

        if (!step.isFirst && step.waitingForPreviousResult && !hasSourceImage) {
            const message = '이전 단계의 이미지를 먼저 생성해 주세요.';
            if (!suppressWarningDialog) {
                this.setState({
                    warning_dialog_show_state: true,
                    warning_dialog_content: message,
                    warning_dialog_button_list: [{
                        title: '확인',
                        event_method: () => this.setState({ warning_dialog_show_state: false }),
                    }],
                });
            }

            return {
                success: false,
                errorType: 'PREVIOUS_STEP_RESULT_REQUIRED',
                message,
            };
        }

        const shouldUseSeriesConsistency =
            String(this.props.series_consistency_yn || "N").toUpperCase() === "Y";
        let resolvedSeriesContextJson = String(this.props.series_context_json || "").trim();
        let resolvedSeriesAnchorImageLink = String(this.props.series_anchor_image_url || "").trim();

        this.setState({
            activeStepId: stepId,
            selectedFinalStepNo: step ? step.stepNumber : null,
        });

        this.updateStep(stepId, {
            prompt: userPrompt,
            ratio: effectiveRatio,
            isLoading: true,
        });

        try {
            // 2번 이후 슬라이드는 팝업 진입 시가 아니라 실제 이미지 생성 직전에
            // 시리즈 컨텍스트가 없을 때만 1번 슬라이드 분석을 보장한다.
            if (shouldUseSeriesConsistency && typeof this.props.ensureSeriesContextReady === 'function') {
                const ensuredContext = await Promise.resolve(
                    this.props.ensureSeriesContextReady(
                        this.props.current_slide_no || step.stepNumber || stepNumber
                    )
                );

                if (ensuredContext) {
                    resolvedSeriesContextJson = String(
                        ensuredContext.series_context_json != null
                            ? ensuredContext.series_context_json
                            : resolvedSeriesContextJson
                    ).trim();
                    resolvedSeriesAnchorImageLink = String(
                        ensuredContext.series_anchor_image_url != null
                            ? ensuredContext.series_anchor_image_url
                            : resolvedSeriesAnchorImageLink
                    ).trim();
                }
            }

            const useSeriesContext =
                shouldUseSeriesConsistency && !!resolvedSeriesContextJson;

            let res;
            const generationTemplateRequest = this.getGenerationTemplateRequest();

            if (hasSourceImage) {
                const formData = new FormData();
                formData.append('prompt', prompt);
                // 기생성 히스토리는 history ID만 전달하고 서버가 스냅샷에서 템플릿을 복원한다.
                // 신규 샘플은 템플릿 코드를 전달한다. Multipart Long은 @RequestParam으로 변환된다.
                if (generationTemplateRequest.ai_studio_history_seq) {
                    formData.append('ai_studio_history_seq', String(generationTemplateRequest.ai_studio_history_seq));
                } else if (generationTemplateRequest.template_cd) {
                    formData.append('template_cd', generationTemplateRequest.template_cd);
                } else if (generationTemplateRequest.ai_image_template_seq) {
                    formData.append('ai_image_template_seq', String(generationTemplateRequest.ai_image_template_seq));
                }

                if (step.file) {
                    formData.append('image', step.file);
                }

                if (defaultImageLink) {
                    formData.append('defaultImageLink', defaultImageLink);
                }

                if (effectiveRatio) {
                    formData.append('ratio', effectiveRatio);
                }

                if (step.style_type_cd) {
                    formData.append('style_type_cd', step.style_type_cd);
                }

                if (step.composition_type_cd) {
                    formData.append('composition_type_cd', step.composition_type_cd);
                }

                if (this.props.service_type) {
                    formData.append('service_type', this.props.service_type);
                }

                if (useSeriesContext) {
                    formData.append('seriesContextJson', resolvedSeriesContextJson);
                    if (resolvedSeriesAnchorImageLink) {
                        formData.append('seriesAnchorImageLink', resolvedSeriesAnchorImageLink);
                    }
                }

                res = await http.post('/rest/shop/genai/inpaint/v2', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
            } else {
                const sendForm = {
                    prompt: prompt,
                    ...generationTemplateRequest,
                    style_type_cd: step.style_type_cd,
                    composition_type_cd: step.composition_type_cd,
                    width: step.width,
                    height: step.height,
                    // ratio: this.props.ratio ? this.props.ratio : effectiveRatio,
                    ratio: effectiveRatio,
                    service_type: this.props.service_type ? this.props.service_type : '',
                    seriesContextJson: useSeriesContext ? resolvedSeriesContextJson : '',
                    seriesAnchorImageLink: useSeriesContext ? resolvedSeriesAnchorImageLink : '',
                };

                res = await http.post('/rest/shop/genai/text-to-image/v2', sendForm, {
                    headers: {
                        'content-type': 'application/json;',
                    },
                });
            }

            if (res.data && ((res.data.code === '200') || res.data.imageUrl)) {
                const imageUrl = res.data.imageUrl;
                const nextResult = `url('${imageUrl}')`;

                await new Promise((resolve) => {
                    this.setState((prevState) => {
                        const currentIndex = prevState.steps.findIndex((item) => item.id === stepId);
                        const nextStepIndex = currentIndex >= 0 ? currentIndex + 1 : -1;

                        return {
                            steps: prevState.steps.map((item, index) => {
                                if (item.id === stepId) {
                                    const nextHistory = [...item.history, nextResult];
                                    return {
                                        ...item,
                                        isLoading: false,
                                        positive_prompt_text: res.data.final_prompt_text || prompt,
                                        history: nextHistory,
                                        historyIndex: nextHistory.length - 1,
                                    };
                                }

                                if (
                                    index === nextStepIndex &&
                                    (item.waitingForPreviousResult || item.sourceFromPreviousStep)
                                ) {
                                    return {
                                        ...item,
                                        uploadedImage: nextResult,
                                        inheritedImage: nextResult,
                                        defaultImageLink: imageUrl,
                                        file: null,
                                        file_name: imageUrl
                                            ? imageUrl.split('/').pop().split('?')[0].split('#')[0]
                                            : '',
                                        waitingForPreviousResult: false,
                                        sourceFromPreviousStep: true,
                                    };
                                }

                                return item;
                            }),
                        };
                    }, resolve);
                });

                await this.ensureStepPreviewRatio(stepId);

                const currentStep = this.state.steps.find((item) => item.id === stepId);
                let shouldRefreshAiStudioList = false;

                if (!this.state.ai_studio_history_seq && currentStep && currentStep.stepNumber === 1) {
                    shouldRefreshAiStudioList = await this.handleFirstStepSuccess(userPrompt, {
                        skipSaveAllSteps: false,
                        skipLoadHistoryList: false,
                    });
                } else if (this.state.ai_studio_history_seq) {
                    const saveRes = await this.saveAllSteps();
                    await this.loadHistoryList();
                    shouldRefreshAiStudioList = !!saveRes;
                }

                if (shouldRefreshAiStudioList) {
                    this.notifyAiStudioListRefresh({
                        ai_studio_history_seq: this.state.ai_studio_history_seq || '',
                        step_no: stepNumber,
                        image_url: imageUrl,
                    });
                }

                await this.loadAiUsage();

                return {
                    success: true,
                    errorType: '',
                    message: ''
                };
            } else {
                if (!suppressWarningDialog) {
                    this.setState({
                        warning_dialog_show_state: true,
                        warning_dialog_content: stepNumber+"단계의 이미지를 생성할 수 없어요.<br/>다시 시도해도 안되면 다른 아이디어를 입력해 주세요.",
                        warning_dialog_button_list: [
                            {
                                title: "확인",
                                event_method: () => {
                                    this.setState({ warning_dialog_show_state: false });
                                }
                            }
                        ]
                    });
                }

                this.updateStep(stepId, { isLoading: false });

                return {
                    success: false,
                    errorType: 'GENERATION_FAIL',
                    message: stepNumber+"단계의 이미지를 생성할 수 없어요.<br/>다시 시도해도 안되면 다른 아이디어를 입력해 주세요."
                };
            }
        } catch (error) {
            console.error('이미지 생성 실패', error);

            const errorMessage =
                error && error.message
                    ? String(error.message)
                    : stepNumber+"단계의 이미지를 생성할 수 없어요.<br/>다시 시도해도 안되면 다른 아이디어를 입력해 주세요.";

            if (!suppressWarningDialog) {
                this.setState({
                    warning_dialog_show_state: true,
                    warning_dialog_content: errorMessage,
                    warning_dialog_button_list: [
                        {
                            title: "확인",
                            event_method: () => {
                                this.setState({ warning_dialog_show_state: false });
                            }
                        }
                    ]
                });
            }

            this.updateStep(stepId, { isLoading: false });

            return {
                success: false,
                errorType: 'GENERATION_FAIL',
                message: errorMessage
            };
        }
    };

    changeHistory = (stepId, direction, event) => {
        if (event) event.stopPropagation();

        this.setState((prevState) => ({
            steps: prevState.steps.map((step) => {
                if (step.id !== stepId) return step;
                if (!step.history.length) return step;

                const nextIndex = Math.max(0, Math.min(step.history.length - 1, step.historyIndex + direction));
                return { ...step, historyIndex: nextIndex };
            }),
        }), async () => {
            await this.ensureStepPreviewRatio(stepId);
            this.scheduleAutoSave(600);
        });
    };

    getStepResultUrl = (step) => {
        if (!step || !step.history.length) return '';
        return step.history[step.historyIndex] || '';
    };

    branchNextStep = (stepId) => {
        if (this.state.tutorialDemoMode) return;
        this.setState((prevState) => {
            const currentIndex = prevState.steps.findIndex((step) => step.id === stepId);
            if (currentIndex < 0) return null;

            const currentStep = prevState.steps[currentIndex];
            const currentResultUrl = this.getStepResultUrl(currentStep);

            if (!currentResultUrl) {
                // window.alert('먼저 현재 단계의 결과물을 생성해주세요.');
                this.setState({
                    warning_dialog_show_state: true,
                    warning_dialog_content: "먼저 현재 단계의 결과물을 생성해주세요.",
                    warning_dialog_button_list: [
                        {
                            title: "확인",
                            event_method: () => {
                                this.setState({ warning_dialog_show_state: false });
                            }
                        }
                    ]
                });
                return null;
            }

            const currentResultLink = currentResultUrl
                .replace(/^url\(['"]?/, '')
                .replace(/['"]?\)$/, '');

            const newStep = {
                ...createStep(currentStep.stepNumber + 1, currentResultUrl),
                style_type_cd: currentStep.style_type_cd,
                composition_type_cd: currentStep.composition_type_cd,
                ratio_cd: currentStep.ratio_cd,
                ratio: currentStep.ratio,
                width: currentStep.width,
                height: currentStep.height,
                defaultImageLink: currentResultLink,
                file: null,
                file_name: currentResultLink ? currentResultLink.split('/').pop().split('?')[0].split('#')[0] : '',
                waitingForPreviousResult: false,
                sourceFromPreviousStep: true,
            };

            const nextSteps = [...prevState.steps];
            nextSteps.splice(currentIndex + 1, 0, newStep);

            const normalizedSteps = this.normalizeSteps(nextSteps);

            return {
                steps: normalizedSteps,
                activeStepId: newStep.id,
                selectedFinalStepNo: newStep.stepNumber,
            };
        }, async () => {
            await this.saveAllStepsImmediately();
        });
    };

    deleteStep = (stepId, event) => {
        if (event) event.stopPropagation();

        this.setState((prevState) => {
            if (prevState.steps.length <= 1) return null;

            const removeIndex = prevState.steps.findIndex((step) => step.id === stepId);
            if (removeIndex < 0) return null;

            const nextSteps = prevState.steps.filter((step) => step.id !== stepId);
            const normalizedSteps = this.normalizeSteps(nextSteps);
            const nextActive = normalizedSteps[Math.max(0, removeIndex - 1)] || normalizedSteps[0] || null;

            return {
                steps: normalizedSteps,
                activeStepId: nextActive ? nextActive.id : null,
                selectedFinalStepNo: nextActive ? nextActive.stepNumber : null,
            };
        }, async () => {
            await this.saveAllStepsImmediately();
        });
    };

    runAllSteps = async () => {
        if (this.state.tutorialDemoMode) return;
        if (this.isCurrentHistoryEditBlocked()) return;
        try {
            this.setState({
                save_dialog_show_state: true,
                save_dialog_content: "AI가 전체 단계를 생성 중입니다..."
            });

            const { steps } = this.state;

            for (let i = 0; i < steps.length; i++) {
                let currentStep = this.state.steps[i];

                this.setState({
                    save_dialog_content: "AI가 전체 단계를 생성 중입니다... <br/>현재 <b style='font-weight: 800; color: #00aeb3'>" + currentStep.stepNumber + "단계</b> 실행 중..."
                });

                // const success = await this.generateNode(step.id);
                // 2단계부터는 직전 단계의 최신 결과 이미지를 현재 단계 source image로 덮어쓰기
                if (i > 0) {
                    const prevStep = this.state.steps[i - 1];
                    const prevResultUrl = this.getStepResultUrl(prevStep);

                    if (!prevResultUrl) {
                        throw new Error(prevStep.stepNumber + "단계 결과 이미지가 없습니다.");
                    }

                    const prevResultLink = prevResultUrl
                        .replace(/^url\(['"]?/, '')
                        .replace(/['"]?\)$/, '');

                    await new Promise((resolve) => {
                        this.setState((prevState) => ({
                            steps: prevState.steps.map((step, idx) => {
                                if (idx !== i) return step;

                                return {
                                    ...step,
                                    uploadedImage: prevResultUrl,
                                    inheritedImage: prevResultUrl,
                                    defaultImageLink: prevResultLink,
                                    file: null,
                                    file_name: prevResultLink
                                        ? prevResultLink.split('/').pop().split('?')[0].split('#')[0]
                                        : '',
                                    waitingForPreviousResult: false,
                                    sourceFromPreviousStep: true,
                                };
                            }),
                        }), resolve);
                    });

                    currentStep = this.state.steps[i];
                }

                const result = await this.generateNode(currentStep.stepNumber, currentStep.id, null, {
                    suppressWarningDialog: true,
                });

                if (!result.success) {
                    this.setState({
                        warning_dialog_show_state: true,
                        warning_dialog_content: result.message,
                        warning_dialog_button_list: [
                            {
                                title: "확인",
                                event_method: () => {
                                    this.setState({ warning_dialog_show_state: false });
                                }
                            }
                        ]
                    });
                    return;
                }
            }

        } catch (e) {
            console.error(e);
            // window.alert("전체 단계 실행 중 오류가 발생했습니다.");
            this.setState({
                warning_dialog_show_state: true,
                warning_dialog_content: "전체 단계 실행 중 오류가 발생했습니다.",
                warning_dialog_button_list: [
                    {
                        title: "확인",
                        event_method: () => {
                            this.setState({ warning_dialog_show_state: false });
                        }
                    }
                ]
            });
        } finally {
            this.setState({
                save_dialog_show_state: false,
                save_dialog_content: ""
            });
        }
    };

    applyToMain = async (applyType) => {
        if (this.state.tutorialDemoMode) return;
        if (this.isCurrentHistoryEditBlocked()) {
            return;
        }
        const { steps, selectedFinalStepNo } = this.state;

        const appliedPrompts = steps
            .filter((step) => step.prompt && step.prompt.trim())
            .map((step) => ({
                stepNumber: step.stepNumber,
                prompt: step.prompt,
                modeText: step.uploadedImage
                    ? '(이미지 기반 변형)'
                    : '(텍스트로만 생성)',
            }));

        // 1단계 찾기   
        const innerFirstStep = steps.find(step => step.stepNumber === 1);
        // 일반 작업은 1단계 사용자 프롬프트가 필요하지만, Starter 샘플은 저장된 샘플 프롬프트만으로도 규칙 적용이 가능합니다.
        const firstStepExecutablePrompt = innerFirstStep
            ? (String(this.state.samplePrompt || '').trim() || String(innerFirstStep.prompt || '').trim())
            : '';
        if (!innerFirstStep || !firstStepExecutablePrompt) {
            this.setState({
                warning_dialog_show_state: true,
                warning_dialog_content: "1단계에 입력하신 내용이 없습니다.<br/>생성할 이미지에 대한 설명을 입력해 주세요.",
                warning_dialog_button_list: [
                    {
                        title: "확인",
                        event_method: () => {
                            this.setState({ warning_dialog_show_state: false });
                        }
                    }
                ]
            });
            return;
        }    

        // if (!appliedPrompts.length) {
        //     this.setState({
        //         warning_dialog_show_state: true,
        //         warning_dialog_content: "프롬프트를 입력해주세요.",
        //         warning_dialog_button_list: [
        //             {
        //                 title: "확인",
        //                 event_method: () => {
        //                     this.setState({ warning_dialog_show_state: false });
        //                 }
        //             }
        //         ]
        //     });
        //     return;
        // }

        const firstStep = steps[0];
        const appliedThumb = innerFirstStep && innerFirstStep.uploadedImage
            ? innerFirstStep.uploadedImage
            : '';

        const selectedStep =
            steps.find((step) => step.stepNumber === selectedFinalStepNo) ||
            steps[steps.length - 1];
        const selectedResult =
            selectedStep && Array.isArray(selectedStep.result_image_list)
                ? (selectedStep.result_image_list[selectedStep.historyIndex] || {})
                : {};

        // saveAllSteps()는 STEP/RESULT를 DELETE 후 INSERT하므로 PK가 매번 새로 발급된다.
        // 적용 전에 선택한 PK를 그대로 사용하지 않고, 저장 후 step_no/result_no로 최신 PK를 다시 찾는다.
        const selectedStepNoForApply = selectedStep ? selectedStep.stepNumber : selectedFinalStepNo;
        const selectedResultNoForApply =
            selectedResult && selectedResult.result_no !== undefined && selectedResult.result_no !== null && selectedResult.result_no !== ''
                ? Number(selectedResult.result_no)
                : (selectedStep && Array.isArray(selectedStep.history) && selectedStep.history.length > 0
                    ? Number(selectedStep.historyIndex) + 1
                    : null);

        let latestSelectedStep = selectedStep || null;
        let latestSelectedResult = selectedResult || {};

        const requireSeriesAnchorImage =
            this.props.require_series_anchor_image === true ||
            String(this.props.require_series_anchor_image || "N").toUpperCase() === "Y";
        const selectedSeriesAnchorImage = this.getStepResultUrl(selectedStep);

        // 시리즈 일관성 ON 상태의 1번 작업만 결과 이미지가 필수다.
        // 2번 이후 작업에는 이 prop을 전달하지 않으므로 이미지 없이도 규칙 적용이 가능하다.
        if (requireSeriesAnchorImage && !selectedSeriesAnchorImage) {
            this.setState({
                warning_dialog_show_state: true,
                warning_dialog_content: "시리즈 일관성을 반영하기 위해 결과 이미지가 필요합니다.<br/>이미지 생성을 해주세요.",
                warning_dialog_button_list: [
                    {
                        title: "확인",
                        event_method: () => {
                            this.setState({ warning_dialog_show_state: false });
                        }
                    }
                ]
            });
            return;
        }

        const requestedApplyType = (applyType === "IMAGE" || applyType === "PROMPT") ? applyType : "";
        const ai_response_type = requestedApplyType || this.props.ai_response_type || 'PROMPT';

        let appliedValue = null;

        if (ai_response_type === 'IMAGE') {
            const selectedImage = this.getStepResultUrl(selectedStep);

            if (!selectedImage) {
                this.setState({
                    warning_dialog_show_state: true,
                    warning_dialog_content: "선택된 단계의 결과 이미지가 없습니다.",
                    warning_dialog_button_list: [
                        {
                            title: "확인",
                            event_method: () => {
                                this.setState({ warning_dialog_show_state: false });
                            }
                        }
                    ]
                });
                return;
            }

            appliedValue = this.extractRawUrl(selectedImage);
        } else {
            appliedValue = appliedPrompts;
        }

        try {
            // 최신 상태 저장
            if (this.state.ai_studio_history_seq) {
                const saveResult = await this.saveAllStepsImmediately();
                if (!saveResult) {
                    throw new Error('작업 저장에 실패했습니다.');
                }
            } else {
                const firstPrompt = steps[0]?.prompt || '';
                const hasStarterPrompt = !!String(this.state.samplePrompt || '').trim();
                if (firstPrompt.trim() || hasStarterPrompt) {
                    const created = await this.handleFirstStepSuccess(firstPrompt, {
                        skipSaveAllSteps: false,
                        skipLoadHistoryList: false,
                    });
                    if (!created) {
                        throw new Error('작업 저장에 실패했습니다.');
                    }
                }
            }

            // saveAllSteps() 이후 STEP/RESULT PK가 새로 발급되므로 최신 상세에서 다시 매칭한다.
            const latestHistorySeq = this.state.ai_studio_history_seq;
            if (latestHistorySeq && selectedStepNoForApply !== undefined && selectedStepNoForApply !== null) {
                const historyRes = await http.get('/rest/shop/aiStudio/historyDetail', {
                    params: { ai_studio_history_seq: latestHistorySeq }
                });
                const historyData = historyRes && historyRes.data ? historyRes.data : {};

                if (historyData.result !== 'success') {
                    throw new Error(historyData.message || '저장된 작업 정보를 다시 불러오지 못했습니다.');
                }

                const latestStepList = Array.isArray(historyData.step_list) ? historyData.step_list : [];
                latestSelectedStep = latestStepList.find(
                    (step) => Number(step.step_no) === Number(selectedStepNoForApply)
                ) || null;

                if (!latestSelectedStep) {
                    throw new Error('저장된 AI 이미지 스튜디오 단계 정보를 찾을 수 없습니다.');
                }

                const latestResultList = Array.isArray(latestSelectedStep.result_image_list)
                    ? latestSelectedStep.result_image_list
                    : [];

                latestSelectedResult = selectedResultNoForApply !== null
                    ? (latestResultList.find(
                        (result) => Number(result.result_no) === Number(selectedResultNoForApply)
                    ) || {})
                    : {};

                // 이미지를 적용하는 경우 결과 PK까지 반드시 최신 값으로 확인한다.
                if (ai_response_type === 'IMAGE') {
                    if (!latestSelectedResult.ai_studio_history_step_result_seq) {
                        throw new Error('저장된 AI 이미지 스튜디오 결과 정보를 찾을 수 없습니다.');
                    }

                    const latestImageUrl =
                        latestSelectedResult.generated_image_url ||
                        latestSelectedResult.generated_thumbnail_url ||
                        '';

                    if (!latestImageUrl) {
                        throw new Error('저장된 AI 이미지 스튜디오 결과 이미지가 없습니다.');
                    }

                    appliedValue = this.extractRawUrl(latestImageUrl);
                }
            }
        } catch (e) {
            console.error('applyToMain 직전 저장 실패', e);
            this.setState({
                warning_dialog_show_state: true,
                warning_dialog_content: e && e.message
                    ? String(e.message)
                    : '작업 저장에 실패했습니다.<br/>다시 시도해주세요.',
                warning_dialog_button_list: [
                    {
                        title: '확인',
                        event_method: () => {
                            this.setState({ warning_dialog_show_state: false });
                        }
                    }
                ]
            });
            return;
        }

        if (this.isPopupMode()) {
            const normalizePostRatio = (ratio) => {
                const value = String(ratio || '').trim();

                if (!value || value === '미선택') {
                    return '';
                }

                return value.replace(/\s*:\s*/g, '/').replace(/\s*\/\s*/g, '/');
            };

            const selectedImageRatio =
                normalizePostRatio(selectedStep ? selectedStep.ratio : '')
                || normalizePostRatio(this.props.ratio)
                || '1/1';

            const applyPayload = {
                ai_response_type,
                appliedValue,
                appliedPrompts,
                appliedImage: ai_response_type === 'IMAGE' ? appliedValue : '',
                appliedThumb,
                selectedFinalStepNo,
                steps: steps.map((step) => ({
                    ...step,
                    modeText: step.uploadedImage
                        ? '(이미지 기반 변형)'
                        : '(텍스트로만 생성)',
                })),
                ai_studio_history_seq: this.state.ai_studio_history_seq || null,
                history_title: this.state.workflowTitle || '',
                ai_studio_history_step_seq: latestSelectedStep
                    ? (latestSelectedStep.ai_studio_history_step_seq || '')
                    : '',
                ai_studio_history_step_result_seq: latestSelectedResult
                    ? (latestSelectedResult.ai_studio_history_step_result_seq || '')
                    : '',
                result_no: latestSelectedResult && latestSelectedResult.result_no
                    ? latestSelectedResult.result_no
                    : (selectedResultNoForApply || ''),
                image_ratio: selectedImageRatio,
                ratio: selectedImageRatio,
                ratio_cd: selectedStep ? (selectedStep.ratio_cd || '') : '',
            };

            try {
                if (this.props.show_apply_rule_loading) {
                    this.setState({ isApplyingRule: true });
                }

                if (this.props.onApplyRule) {
                    await Promise.resolve(this.props.onApplyRule(applyPayload));
                }

                this.setState({ isApplyingRule: false }, () => {
                    this.closeModal();
                });
            } catch (e) {
                console.error('자동화 규칙 적용 후처리 실패', e);
                this.setState({
                    isApplyingRule: false,
                    warning_dialog_show_state: true,
                    warning_dialog_content:
                        (e && e.message)
                            ? String(e.message)
                            : '시리즈 기준 분석에 실패했습니다.<br/>다시 시도해주세요.',
                    warning_dialog_button_list: [
                        {
                            title: '확인',
                            event_method: () => {
                                this.setState({ warning_dialog_show_state: false });
                            }
                        }
                    ]
                });
            }
            return;
        }

        this.setState({
            isApplied: true,
            appliedPrompts,
            appliedThumb,
            isModalOpen: false,
        });
    };

    getSelectedFinalStep = () => {
        const { steps, selectedFinalStepNo } = this.state;

        return (
            steps.find((step) => step.stepNumber === selectedFinalStepNo) ||
            steps[steps.length - 1] ||
            null
        );
    };

    getAiResponseType = () => {
        return this.props.ai_response_type || 'PROMPT';
    };

    isOpenedFromAiStudioList = () => {
        return this.props.opened_from === "AI_STUDIO_LIST" || this.props.openedFrom === "AI_STUDIO_LIST";
    };

    notifyAiStudioListRefresh = (payload = {}) => {
        if (!this.isOpenedFromAiStudioList()) {
            return;
        }

        if (typeof this.props.onRefreshStudioImageList === 'function') {
            this.props.onRefreshStudioImageList({
                reset: true,
                start: 0,
                ...payload,
            });
        }
    };

    resetAppliedImage = () => {
        const confirmed = window.confirm('저장된 자동화 규칙을 삭제하시겠습니까?');
        if (!confirmed) return;

        this.setState({
            isApplied: false,
            appliedPrompts: [],
            appliedThumb: '',
        });
    };

    renderOptionGroup = (step, title, listKey, selectedKey, clickHandler) => {
        const optionList = this.state[listKey] || [];
        const tutorialTarget = {
            style_type_list: 'AI_STUDIO_OPTION_STYLE',
            composition_type_list: 'AI_STUDIO_OPTION_COMPOSITION',
            ratio_list: 'AI_STUDIO_OPTION_RATIO',
        }[listKey];

        if (!optionList.length) {
            return (
                <div
                    style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}
                    data-instagram-tutorial-target={tutorialTarget}
                >
                    <span className="setting-section-title">{title}</span>
                    <div className="pill-option-group">
                        <button type="button" className="pill-option-btn" disabled>
                            <span className="pill-option-text">불러오는 중...</span>
                        </button>
                    </div>
                </div>
            );
        }

        return (
            <div
                style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}
                data-instagram-tutorial-target={tutorialTarget}
            >
                <span className="setting-section-title">{title}</span>
                <div className="pill-option-group">
                    {optionList.map((obj) => {
                        const selectedValue =
                            selectedKey === 'ratio' ? step.ratio_cd : step[selectedKey];

                        const optionValue = obj.code_cd;

                        const isActive = selectedValue === optionValue;

                        return (
                            <button
                                type="button"
                                key={`${listKey}_${obj.code_cd}`}
                                className={`pill-option-btn ${isActive ? 'active' : ''}`}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    clickHandler(obj);
                                }}
                            >
                                <div
                                    className="pill-icon-thumb"
                                    style={obj.val2 ? { backgroundImage: `url(${obj.val2})` } : {}}
                                />
                                <span className="pill-option-text">
                                    {listKey === 'ratio_list'
                                        ? (obj.val3 || obj.code_name || '미선택')
                                        : (obj.code_name || '미선택')}
                                </span>
                            </button>
                        );
                    })}
                </div>
            </div>
        );
    };

    renderStepNode = (step, index) => {
        const { steps, activeStepId } = this.state;
        const isActive = activeStepId === step.id;
        const hasNext = index < steps.length - 1;
        const previewImage = this.getStepResultUrl(step);
        const previewRawUrl = this.extractRawUrl(previewImage);
        const previewAspectRatio =
            (previewRawUrl && step.historyRatioMap && step.historyRatioMap[previewRawUrl])
                || (step.ratio ? step.ratio.replace(':', ' / ') : '')
                || (step.width && step.height ? `${step.width} / ${step.height}` : '')
                || '4 / 5';
        const hasPreview = Boolean(previewImage);
        const historyLength = step.history.length;
        const previewUpload = step.uploadedImage || step.inheritedImage;
        const isAutomationEditBlocked = this.isCurrentHistoryEditBlocked();

        return (
            <div
                key={step.id}
                className={`step-node ${isActive ? 'active' : ''} ${hasNext ? 'has-next' : ''}`}
                id={`node_${step.id}`}
                onClick={() => this.focusStep(step.id)}
            >
                <div className="node-timeline-track">
                    <div className="node-number">{step.stepNumber}</div>
                    <div className="timeline-line" />
                </div>

                <div className="node-content-split">
                    <div className="config-pane">
                        <div className="node-header">
                            <div className="node-title-wrap">
                                <div className="node-badge" id={`nodeBadge_${step.id}`}>
                                    {step.stepNumber}단계
                                </div>
                                <div className="node-title-text">{step.title}</div>
                            </div>

                            {/* {!step.isFirst ? (
                                <button
                                    type="button"
                                    className="btn btn-outline btn-sm"
                                    style={{ color: '#dc2626', borderColor: '#fecaca' }}
                                    onClick={(e) => this.deleteStep(step.id, e)}
                                >
                                    단계 삭제
                                </button>
                            ) : null} */}

                        {!step.isFirst ? (
                            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                <button
                                    type="button"
                                    className="btn btn-outline btn-sm"
                                    data-instagram-tutorial-target="AI_STUDIO_STEP_MOVE_UP"
                                    disabled={isAutomationEditBlocked || index <= 1}
                                    onClick={(e) => this.moveStep(step.id, -1, e)}
                                >
                                    ↑ 위로
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-outline btn-sm"
                                    data-instagram-tutorial-target="AI_STUDIO_STEP_MOVE_DOWN"
                                    disabled={isAutomationEditBlocked || index === 0 || index === steps.length - 1}
                                    onClick={(e) => this.moveStep(step.id, 1, e)}
                                >
                                    ↓ 아래로
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-outline btn-outline-red btn-sm"
                                    data-instagram-tutorial-target="AI_STUDIO_STEP_DELETE"
                                    style={{ color: '#dc2626', borderColor: '#fecaca' }}
                                    disabled={isAutomationEditBlocked}
                                    onClick={(e) => this.deleteStep(step.id, e)}
                                >
                                    단계 삭제
                                </button>
                            </div>
                        ) : null}
                        </div>

                        {step.isFirst && this.state.sampleGuide && this.state.sampleGuide.sceneDescription ? (
                            <div className={`sample-scene-guide ${this.state.sampleGuide.resultExampleUrl ? 'has-result-example' : ''}`}>
                                {this.state.sampleGuide.title ? (
                                    <div className="sample-scene-guide-title">{this.state.sampleGuide.title}</div>
                                ) : null}
                                <div className="sample-scene-guide-text">{this.state.sampleGuide.sceneDescription}</div>
                                {this.state.sampleGuide.resultExampleUrl ? (
                                    <button
                                        type="button"
                                        className="sample-result-example-thumb"
                                        title="결과 예시 확대"
                                        aria-label="결과 예시 확대"
                                        onClick={(e) => this.openImageZoom(
                                            this.state.sampleGuide.resultExampleUrl,
                                            `${this.state.sampleGuide.title || '샘플'} 결과 예시`,
                                            e
                                        )}
                                    >
                                        <img
                                            src={this.state.sampleGuide.resultExampleUrl}
                                            alt={`${this.state.sampleGuide.title || '샘플'} 결과 예시`}
                                            loading="lazy"
                                        />
                                        <span className="sample-result-example-label">결과 예시</span>
                                    </button>
                                ) : null}
                            </div>
                        ) : null}

                        <div className={`prompt-flex-box ${isAutomationEditBlocked ? 'automation-protected-disabled' : ''}`} onClick={(e) => e.stopPropagation()}>
                            {step.isFirst ? (
                                <div className="prompt-actions-left">
                                    <button
                                        type="button"
                                        className="icon-btn-round"
                                        data-instagram-tutorial-target="AI_STUDIO_IMAGE_INPUT"
                                        title="사진 첨부"
                                        disabled={isAutomationEditBlocked}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            this.triggerFileInput(step.id);
                                        }}
                                    >
                                        <svg className="svg-icon-lg" viewBox="0 0 20 20" fill="currentColor">
                                            <path d="M17.5 10C17.5 10.1658 17.4342 10.3247 17.3169 10.4419C17.1997 10.5592 17.0408 10.625 16.875 10.625H10.625V16.875C10.625 17.0408 10.5592 17.1997 10.4419 17.3169C10.3247 17.4342 10.1658 17.5 10 17.5C9.83424 17.5 9.67527 17.4342 9.55806 17.3169C9.44085 17.1997 9.375 17.0408 9.375 16.875V10.625H3.125C2.95924 10.625 2.80027 10.5592 2.68306 10.4419C2.56585 10.3247 2.5 10.1658 2.5 10C2.5 9.83424 2.56585 9.67527 2.68306 9.55806C2.80027 9.44085 2.95924 9.375 3.125 9.375H9.375V3.125C9.375 2.95924 9.44085 2.80027 9.55806 2.68306C9.67527 2.56585 9.83424 2.5 10 2.5C10.1658 2.5 10.3247 2.56585 10.4419 2.68306C10.5592 2.80027 10.625 2.95924 10.625 3.125V9.375H16.875C17.0408 9.375 17.1997 9.44085 17.3169 9.55806C17.4342 9.67527 17.5 9.83424 17.5 10Z" />
                                        </svg>
                                    </button>
                                    <input
                                        type="file"
                                        id={`fileInput_${step.id}`}
                                        style={{ display: 'none' }}
                                        accept="image/*"
                                        onChange={(e) => this.handleStepUpload(step.id, e)}
                                    />
                                </div>
                            ) : null}

                            <div className="prompt-input-area">
                                {step.waitingForPreviousResult && !previewUpload ? (
                                    <div className="source-waiting-inline">
                                        이전 단계의 새 결과 이미지가 여기에 적용됩니다
                                    </div>
                                ) : previewUpload ? (
                                    <div className="upload-preview-inline" style={{ backgroundImage: previewUpload }}>
                                        {step.isFirst && step.uploadedImage ? (
                                            <button type="button" className="remove-preview-btn" disabled={isAutomationEditBlocked} onClick={(e) => this.removeUploadedImage(step.id, e)}>
                                                <svg style={{ width: '14px', height: '14px' }} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                                                    <line x1="18" y1="6" x2="6" y2="18" />
                                                    <line x1="6" y1="6" x2="18" y2="18" />
                                                </svg>
                                            </button>
                                        ) : null}
                                        {!step.isFirst ? <div className="source-label">이전 결과 이미지</div> : null}
                                    </div>
                                ) : null}

                                <textarea
                                    className="prompt-textarea"
                                    data-instagram-tutorial-target="AI_STUDIO_PROMPT"
                                    placeholder={
                                        step.isFirst
                                            ? (
                                                this.state.samplePrompt && this.state.sampleGuide?.promptPlaceholder
                                                    ? this.state.sampleGuide.promptPlaceholder
                                                    : '생성할 이미지에 대한 상세한 설명을 적어주세요.\n예) 긴 머리를 가진 20대 한국인 여성 헤어 모델 사진 만들어줘.'
                                            )
                                            : '어떤 부분을 어떻게 바꿀지 적어주세요.\n예) 인물의 얼굴은 유지하고, 옷을 고급스러운 드레스로 변경해줘.'
                                    }
                                    value={step.prompt}
                                    readOnly={isAutomationEditBlocked}
                                    onClick={(e) => e.stopPropagation()}
                                    onPointerDown={this.handleTextareaResizeStart}
                                    onChange={(e) => this.handlePromptChange(step.id, e)}
                                />
                            </div>

                            <div className="prompt-actions-right">
                                <button
                                    type="button"
                                    className="icon-btn-submit"
                                    data-instagram-tutorial-target="AI_STUDIO_GENERATE"
                                    title="AI 렌더링 실행"
                                    disabled={isAutomationEditBlocked || step.isLoading}
                                    onClick={(e) => this.generateNode(step.stepNumber, step.id, e)}
                                >
                                    {step.isLoading ? (
                                        <svg
                                            className="svg-icon-lg svg-stroke"
                                            viewBox="0 0 24 24"
                                            style={{ animation: 'aiImageStudioSpin 1s linear infinite' }}
                                        >
                                            <circle cx="12" cy="12" r="9" />
                                            <path d="M12 7v5l3 2" />
                                        </svg>
                                    ) : (
                                        <svg className="svg-icon-lg" viewBox="1178 306 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                            <path d="M1191.27 328.652C1191.07 328.85 1190.8 328.961 1190.52 328.961C1190.24 328.961 1189.97 328.85 1189.77 328.652C1189.58 328.451 1189.47 328.182 1189.47 327.902C1189.47 327.622 1189.58 327.353 1189.77 327.152L1197.42 319.48L1180.05 319.48C1179.77 319.48 1179.5 319.369 1179.31 319.172C1179.11 318.975 1179 318.707 1179 318.428C1179 318.148 1179.11 317.881 1179.31 317.683C1179.5 317.486 1179.77 317.375 1180.05 317.375L1197.42 317.375L1189.77 309.703C1189.61 309.499 1189.52 309.239 1189.54 308.975C1189.55 308.71 1189.66 308.46 1189.84 308.273C1190.03 308.086 1190.28 307.975 1190.54 307.962C1190.81 307.949 1191.06 308.035 1191.27 308.203L1200.69 317.678C1200.89 317.877 1201 318.147 1201 318.428C1201 318.709 1200.89 318.978 1200.69 319.178L1191.27 328.652Z" fill="currentColor" />
                                        </svg>
                                    )}
                                </button>
                            </div>
                        </div>

                        <div className={`node-settings ${isAutomationEditBlocked ? 'automation-protected-disabled' : ''}`} style={isAutomationEditBlocked ? { pointerEvents: 'none' } : undefined} onClick={(e) => e.stopPropagation()}>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '32px', flexWrap: 'wrap' }}>
                                {this.renderOptionGroup(
                                    step,
                                    '이미지 스타일',
                                    'style_type_list',
                                    'style_type_cd',
                                    (obj) => this.setType(step.id, obj, 'style_type_cd')
                                )}

                                {this.renderOptionGroup(
                                    step,
                                    '카메라 구도',
                                    'composition_type_list',
                                    'composition_type_cd',
                                    (obj) => this.setType(step.id, obj, 'composition_type_cd')
                                )}

                                {this.renderOptionGroup(
                                    step,
                                    '비율',
                                    'ratio_list',
                                    'ratio',
                                    (obj) => this.setTypeRatio(step.id, obj)
                                )}
                            </div>
                        </div>

                        <div className="config-pane-footer">
                            <button
                                type="button"
                                className="btn btn-outline"
                                data-instagram-tutorial-target="AI_STUDIO_NEXT_STEP"
                                disabled={isAutomationEditBlocked}
                                onClick={() => this.branchNextStep(step.id)}
                            >
                                결과물 수정
                            </button>
                            {this.isPopupMode() && this.isOpenedFromAiStudioList() ? (
                                <button
                                    type="button"
                                    className="btn btn-outline"
                                    style={{ padding: '0 28px' }}
                                    data-instagram-tutorial-target="AI_STUDIO_STEP_REGISTER_IMAGE"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        this.setState({
                                            activeStepId: step.id,
                                            selectedFinalStepNo: step.stepNumber,
                                        }, () => this.applyToMain("IMAGE"));
                                    }}
                                >
                                    콘텐츠 등록
                                </button>
                            ) : null}
                        </div>
                    </div>

                    <div className="result-pane" data-instagram-tutorial-target="AI_STUDIO_RESULT">
                        <div className="result-header">
                            <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className="svg-icon-sm">
                                    <path d="M17.9453 17.0547L14.5625 13.6797C15.7564 12.2583 16.3555 10.4308 16.2348 8.57844C16.114 6.72607 15.2828 4.99182 13.9146 3.73738C12.5463 2.48294 10.7465 1.80518 8.89063 1.84545C7.03477 1.88571 5.2661 2.6409 3.9535 3.9535C2.6409 5.2661 1.88571 7.03477 1.84545 8.89063C1.80518 10.7465 2.48294 12.5463 3.73738 13.9146C4.99182 15.2828 6.72607 16.114 8.57844 16.2348C10.4308 16.3555 12.2583 15.7564 13.6797 14.5625L17.0547 17.9453C17.1741 18.0608 17.3338 18.1254 17.5 18.1254C17.6662 18.1254 17.8258 18.0608 17.9453 17.9453C18.0627 17.8268 18.1285 17.6668 18.1285 17.5C18.1285 17.3332 18.0627 17.1732 17.9453 17.0547ZM3.125 9.0625C3.125 7.88817 3.47323 6.74022 4.12565 5.7638C4.77807 4.78738 5.70538 4.02636 6.79032 3.57696C7.87525 3.12757 9.06909 3.00999 10.2208 3.23909C11.3726 3.46819 12.4306 4.03368 13.2609 4.86405C14.0913 5.69443 14.6568 6.75239 14.8859 7.90415C15.115 9.05591 14.9974 10.2497 14.548 11.3347C14.0986 12.4196 13.3376 13.3469 12.3612 13.9993C11.3848 14.6518 10.2368 15 9.0625 15C7.48841 14.9979 5.97938 14.3717 4.86634 13.2587C3.75329 12.1456 3.12707 10.6366 3.125 9.0625Z" fill="currentColor" />
                                </svg>
                                실시간 결과 캔버스
                            </span>
                        </div>

                        <div className="canvas-wrap">
                            <div className={`preview-canvas-container ${hasPreview ? 'has-result' : ''}`}
                                style={{ aspectRatio: previewAspectRatio }}
                            >
                                {!hasPreview && !step.isLoading ? (
                                    <div className="canvas-default-state">
                                        <svg style={{ width: '48px', opacity: 0.3, marginBottom: '8px' }} viewBox="0 0 24 24" fill="none">
                                            <rect x="3" y="3" width="18" height="18" rx="4" stroke="currentColor" strokeWidth="2" />
                                            <path d="M21 15L16 10L5 21" stroke="currentColor" strokeWidth="2" />
                                        </svg>
                                        <div style={{ fontSize: '15px', fontWeight: 600 }}>작업을 실행하면 결과가 표시됩니다.</div>
                                    </div>
                                ) : null}

                                {step.isLoading ? (
                                    <div className="loading-state">
                                        <svg style={{ width: '48px', marginBottom: '16px', color: 'var(--primary-mint)' }} viewBox="0 0 24 24" fill="none">
                                            <rect x="3" y="3" width="18" height="18" rx="4" stroke="currentColor" strokeWidth="2" />
                                            <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor" />
                                            <path d="M21 15L16 10L5 21" stroke="currentColor" strokeWidth="2" />
                                        </svg>
                                        <div style={{ fontSize: '16px', fontWeight: 800, color: 'var(--deep-navy)' }}>AI 렌더링 진행 중...</div>
                                        <div className="loading-bar-container"><div className="loading-bar" /></div>
                                    </div>
                                ) : null}

                                {hasPreview ? (
                                    <div className="preview-canvas-image" style={{ display: 'block', backgroundImage: previewImage }}>
                                        {this.state.tutorialDemoMode ? <div className="tutorial-demo-badge">튜토리얼 예시</div> : null}
                                        <div className="preview-status-badge">✅ {step.stepNumber}단계 완료</div>
                                        <button
                                            type="button"
                                            className="expand-icon-btn"
                                            title="결과 이미지 확대"
                                            aria-label="결과 이미지 확대"
                                            onClick={(e) => this.openImageZoom(previewRawUrl, `${step.stepNumber}단계 결과 이미지`, e)}
                                        >
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M14.2502 10.5C14.2502 10.6989 14.1712 10.8896 14.0305 11.0303C13.8899 11.171 13.6991 11.25 13.5002 11.25H11.2502V13.5C11.2502 13.6989 11.1712 13.8896 11.0305 14.0303C10.8899 14.171 10.6991 14.25 10.5002 14.25C10.3013 14.25 10.1105 14.171 9.96988 14.0303C9.82923 13.8896 9.75021 13.6989 9.75021 13.5V11.25H7.50021C7.3013 11.25 7.11054 11.171 6.96988 11.0303C6.82923 10.8896 6.75021 10.6989 6.75021 10.5C6.75021 10.3011 6.82923 10.1103 6.96988 9.96964C7.11054 9.82899 7.3013 9.74997 7.50021 9.74997H9.75021V7.49997C9.75021 7.30106 9.82923 7.11029 9.96988 6.96964C10.1105 6.82899 10.3013 6.74997 10.5002 6.74997C10.6991 6.74997 10.8899 6.82899 11.0305 6.96964C11.1712 7.11029 11.2502 7.30106 11.2502 7.49997V9.74997H13.5002C13.6991 9.74997 13.8899 9.82899 14.0305 9.96964C14.1712 10.1103 14.2502 10.3011 14.2502 10.5ZM21.5308 21.5306C21.4612 21.6003 21.3785 21.6556 21.2874 21.6934C21.1964 21.7311 21.0988 21.7506 21.0002 21.7506C20.9017 21.7506 20.8041 21.7311 20.713 21.6934C20.622 21.6556 20.5392 21.6003 20.4696 21.5306L15.7765 16.8365C14.1431 18.1971 12.048 18.8755 9.92715 18.7307C7.80629 18.5859 5.82289 17.629 4.38956 16.0591C2.95623 14.4892 2.18333 12.4271 2.23163 10.3019C2.27993 8.17663 3.14571 6.15181 4.64888 4.64864C6.15205 3.14547 8.17687 2.27968 10.3021 2.23138C12.4274 2.18308 14.4894 2.95599 16.0593 4.38932C17.6293 5.82265 18.5861 7.80604 18.7309 9.92691C18.8757 12.0478 18.1973 14.1428 16.8368 15.7762L21.5308 20.4693C21.6006 20.539 21.6559 20.6217 21.6936 20.7128C21.7314 20.8038 21.7508 20.9014 21.7508 21C21.7508 21.0985 21.7314 21.1961 21.6936 21.2872C21.6559 21.3782 21.6006 21.4609 21.5308 21.5306ZM10.5002 17.25C11.8352 17.25 13.1403 16.8541 14.2503 16.1124C15.3603 15.3707 16.2255 14.3165 16.7364 13.0831C17.2473 11.8497 17.381 10.4925 17.1205 9.18311C16.8601 7.87374 16.2172 6.671 15.2732 5.727C14.3292 4.78299 13.1264 4.14012 11.8171 3.87967C10.5077 3.61922 9.1505 3.75289 7.9171 4.26378C6.6837 4.77467 5.62949 5.63984 4.88779 6.74987C4.14609 7.8599 3.75021 9.16495 3.75021 10.5C3.7522 12.2896 4.464 14.0053 5.72944 15.2708C6.99488 16.5362 8.71061 17.248 10.5002 17.25Z" fill="#333333"/>
                                            </svg>

                                        </button>
                                        <button
                                            type="button"
                                            className="download-icon-btn"
                                            data-instagram-tutorial-target="AI_STUDIO_RESULT_DOWNLOAD"
                                            onClick={(e) => this.downloadStepImage(step, e)}
                                        ></button>
                                        {historyLength > 1 ? (
                                            <div className="history-nav-overlay" data-instagram-tutorial-target="AI_STUDIO_RESULT_HISTORY">
                                                <div
                                                    className={`history-nav-btn ${step.historyIndex <= 0 ? 'disabled' : ''}`}
                                                    onClick={(e) => step.historyIndex > 0 && this.changeHistory(step.id, -1, e)}
                                                >
                                                    <svg style={{ width: '14px' }} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
                                                        <path d="M15 18l-6-6 6-6" />
                                                    </svg>
                                                </div>
                                                <div style={{ fontSize: '13px', fontWeight: 800, minWidth: '32px', textAlign: 'center' }}>
                                                    {step.historyIndex + 1}/{historyLength}
                                                </div>
                                                <div
                                                    className={`history-nav-btn ${step.historyIndex >= historyLength - 1 ? 'disabled' : ''}`}
                                                    onClick={(e) => step.historyIndex < historyLength - 1 && this.changeHistory(step.id, 1, e)}
                                                >
                                                    <svg style={{ width: '14px' }} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
                                                        <path d="M9 18l6-6-6-6" />
                                                    </svg>
                                                </div>
                                            </div>
                                        ) : null}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    normalizeSteps = (steps) => {
        return steps.map((step, index) => ({
            ...step,
            stepNumber: index + 1,
            isFirst: index === 0,
            title:
                index === 0
                    ? '텍스트로 AI 이미지 제작하기'
                    : '이전 결과물로 AI 이미지 수정하기',
        }));
    };

    moveStep = (stepId, direction, event) => {
        if (event) event.stopPropagation();

        this.setState((prevState) => {
            const currentIndex = prevState.steps.findIndex((step) => step.id === stepId);
            if (currentIndex < 0) return null;

            if (currentIndex === 0) return null;

            const targetIndex = currentIndex + direction;

            if (targetIndex < 0 || targetIndex >= prevState.steps.length) return null;
            if (targetIndex === 0) return null;

            const nextSteps = [...prevState.steps];
            const temp = nextSteps[currentIndex];
            nextSteps[currentIndex] = nextSteps[targetIndex];
            nextSteps[targetIndex] = temp;

            const normalizedSteps = this.normalizeSteps(nextSteps);
            const activeStep = normalizedSteps.find((step) => step.id === stepId) || null;

            return {
                steps: normalizedSteps,
                activeStepId: stepId,
                selectedFinalStepNo: activeStep ? activeStep.stepNumber : prevState.selectedFinalStepNo,
            };
        }, async () => {
            await this.saveAllStepsImmediately();
        });
    };

    getRandomPrompt = (stepId) => {
        const step = this.state.steps.find((item) => item.id === stepId);
        if (!step) return;

        http.get('/rest/common/sampple/prompts?prompt_seq=' + (step.before_prompt_seq || ''))
            .then((res) => {
                if (res.data) {
                    this.updateStep(stepId, {
                        prompt: (res.data.sample_prompts || '').substring(0, prompt_max_length),
                        before_prompt_seq: res.data.sample_prompt_seq || '',
                    });
                }
            })
            .catch((e) => {
                console.error('추천 프롬프트 조회 실패', e);
            });
    };

    extractUrl = (value) => {
        if (!value) return '';

        if (typeof value !== 'string') return '';

        return value
            .replace(/^url\(['"]?/, '')
            .replace(/['"]?\)$/, '')
            .trim();
    };

    getStepGeneratedImageUrl = (step) => {
        if (!step || !step.history || !step.history.length) return '';
        return this.extractUrl(step.history[step.historyIndex] || '');
    };

    getStepSourceImageUrl = (step) => {
        if (!step) return '';

        if (step.defaultImageLink) {
            return step.defaultImageLink;
        }

        if (step.uploadedImage) {
            return this.extractUrl(step.uploadedImage);
        }

        if (step.inheritedImage) {
            return this.extractUrl(step.inheritedImage);
        }

        return '';
    };

    buildSaveAllStepsPayload = () => {
        const {
            ai_studio_history_seq,
            workflowTitle,
            steps,
            selectedFinalStepNo,
        } = this.state;

        const step_list = (steps || []).map((step) => {
            const generatedImageUrl = this.getStepGeneratedImageUrl(step);
            const sourceImageUrl = this.getStepSourceImageUrl(step);

            const resultImageList = (step.history || []).map((item, idx) => {
                const url = this.extractUrl(item);

                return {
                    result_no: idx + 1,
                    generated_image_url: url,
                    generated_thumbnail_url: url,
                    is_selected_yn: idx === step.historyIndex ? 'Y' : 'N',
                };
            });

            return {
                step_no: step.stepNumber,
                prompt_text: step.prompt || '',
                positive_prompt_text: step.positive_prompt_text || '',
                negative_prompt_text: step.negative_prompt_text || '',
                style_type_cd: step.style_type_cd || '',
                camera_angle_cd: step.composition_type_cd || '',
                ratio_cd: step.ratio_cd || '',
                source_image_url: sourceImageUrl,
                generated_image_url: generatedImageUrl,
                generated_thumbnail_url: generatedImageUrl,
                run_status: generatedImageUrl ? 'DONE' : (step.run_status || 'READY'),
                error_message: step.error_message || '',
                is_final_selected: selectedFinalStepNo === step.stepNumber ? 'Y' : 'N',
                result_image_list: resultImageList,
            };
        });

        return {
            ai_studio_history_seq,
            history_title: workflowTitle || '',
            workflow_status: 'DONE',
            step_list,
        };
    };

    saveAllSteps = async () => {
        if (this.state.tutorialDemoMode) return null;
        if (this.isCurrentHistoryEditBlocked()) return null;
        const payload = this.buildSaveAllStepsPayload();

        if (!payload.ai_studio_history_seq) {
            console.error('ai_studio_history_seq가 없습니다.');
            return;
        }

        try {
            const res = await http.post('/rest/shop/aiStudio/saveAllSteps', payload, {
                headers: {
                    'content-type': 'application/json;',
                },
            });

            if (res.data && res.data.result === 'success') {
                await new Promise((resolve) => {
                    this.setState({
                        selectedHistorySeq: payload.ai_studio_history_seq,
                        // 과거 갤러리 STEP을 열어온 상태라도 저장이 완료되면
                        // 화면의 현재 내용이 STEP_CURRENT 기준이 되므로 이후 복제는 CURRENT를 사용한다.
                        duplicateSourceHistoryStepSeq: null,
                    }, resolve);
                });
                return res.data;
            } else {
                console.error('전체 step 저장 실패', res.data);
            }
        } catch (e) {
            console.error('전체 step 저장 실패', e);
        }

        return null;
    };

    handleFirstStepSuccess = async (prompt, options = {}) => {
        const {
            skipSaveAllSteps = false,
            skipLoadHistoryList = false,
        } = options;

        const starterSample = !!String(this.state.samplePrompt || '').trim();
        const title = starterSample && this.state.sampleGuide && this.state.sampleGuide.title
            ? this.state.sampleGuide.title
            : this.makeWorkflowTitle(prompt);
        const starterMeta = starterSample ? this.buildStarterMetaSnapshot() : null;

        const createRes = await http.post('/rest/shop/aiStudio/createHistory', {
            history_title: title,
            auto_yn: "N",
            starter_sample_yn: starterSample ? "Y" : "N",
            starter_prompt_snapshot: starterSample ? String(this.state.samplePrompt || '') : '',
            starter_meta_snapshot_json: starterMeta ? JSON.stringify(starterMeta) : '',
            starter_result_example_url: starterSample && this.state.sampleGuide
                ? String(this.state.sampleGuide.resultExampleUrl || '')
                : '',
        });

        if (
            createRes.data &&
            createRes.data.result === 'success' &&
            createRes.data.ai_studio_history_seq
        ) {
            const newHistorySeq = createRes.data.ai_studio_history_seq;

            await new Promise((resolve) => {
                this.setState({
                    ai_studio_history_seq: newHistorySeq,
                    selectedHistorySeq: newHistorySeq,
                    workflowTitle: title,
                }, resolve);
            });

            if (!skipSaveAllSteps) {
                const saveResult = await this.saveAllSteps();
                if (!saveResult) {
                    return false;
                }
            }

            if (!skipLoadHistoryList) {
                await this.loadHistoryList();
            }

            return true;
        }

        return false;
    };

    selectFinalStep = (stepNo) => {
        this.setState({
            selectedFinalStepNo: stepNo,
        });
    };

    makeWorkflowTitle = (prompt) => {
        const cleaned = (prompt || '')
            .replace(/\s+/g, ' ')
            .trim();

        if (!cleaned) return '새 작업';
        return cleaned.length > 20 ? cleaned.substring(0, 20) + '...' : cleaned;
    };

    scheduleAutoSave = (delay = 800) => {
        if (this.state.tutorialDemoMode) return;
        if (this.isCurrentHistoryEditBlocked()) return;
        if (this.autoSaveTimer) {
            clearTimeout(this.autoSaveTimer);
        }

        this.autoSaveTimer = setTimeout(async () => {
            this.autoSaveTimer = null;

            if (!this.state.ai_studio_history_seq) {
                return;
            }

            await this.saveAllSteps();
            await this.loadHistoryList();
        }, delay);
    };

    saveAllStepsImmediately = async () => {
        if (this.state.tutorialDemoMode) return null;
        if (this.isCurrentHistoryEditBlocked()) return null;
        if (this.autoSaveTimer) {
            clearTimeout(this.autoSaveTimer);
            this.autoSaveTimer = null;
        }

        if (!this.state.ai_studio_history_seq) {
            return;
        }

        const saveResult = await this.saveAllSteps();
        if (!saveResult) {
            return null;
        }

        await this.loadHistoryList();
        return saveResult;
    };

    // 자동 저장은 유지하고, 푸터의 저장 버튼에서 동일한 저장 API를 즉시 호출한다.
    handleManualSave = async () => {
        if (this.state.isManuallySaving || this.state.tutorialDemoMode || this.isCurrentHistoryEditBlocked()) return;

        const firstPrompt = this.state.steps[0]?.prompt || '';
        const hasStarterPrompt = !!String(this.state.samplePrompt || '').trim();
        if (!this.state.ai_studio_history_seq && !firstPrompt.trim() && !hasStarterPrompt) {
            this.setState({
                warning_dialog_show_state: true,
                warning_dialog_content: '저장할 작업 내용이 없습니다.',
                warning_dialog_button_list: [{
                    title: '확인',
                    event_method: () => this.setState({ warning_dialog_show_state: false }),
                }],
            });
            return;
        }

        if (this.autoSaveTimer) {
            clearTimeout(this.autoSaveTimer);
            this.autoSaveTimer = null;
        }

        this.setState({
            isManuallySaving: true,
            save_dialog_show_state: true,
            save_dialog_content: '저장 중입니다.',
            save_dialog_button_list: [{ title: '확인', type: '1', display_yn: 'N' }],
        });

        try {
            const saved = this.state.ai_studio_history_seq
                ? await this.saveAllStepsImmediately()
                : await this.handleFirstStepSuccess(firstPrompt);
            if (!saved) throw new Error('작업 저장에 실패했습니다.');

            this.notifyAiStudioListRefresh({
                ai_studio_history_seq: this.state.ai_studio_history_seq || '',
            });
            this.setState({
                isManuallySaving: false,
                save_dialog_show_state: true,
                save_dialog_content: '저장이 완료되었습니다.',
                save_dialog_button_list: [{
                    title: '확인',
                    type: '1',
                    display_yn: 'Y',
                    event_method: () => this.setState({ save_dialog_show_state: false }),
                }],
            });
        } catch (error) {
            console.error('AI 이미지 스튜디오 수동 저장 실패', error);
            this.setState({
                isManuallySaving: false,
                save_dialog_show_state: false,
                warning_dialog_show_state: true,
                warning_dialog_content: error?.response?.data?.message || error?.message || '작업 저장에 실패했습니다.',
                warning_dialog_button_list: [{
                    title: '확인',
                    event_method: () => this.setState({ warning_dialog_show_state: false }),
                }],
            });
        }
    };

    getStepDownloadFileName = (step, imageUrl) => {
        const seq = step && (step.ai_studio_history_step_seq || step.seq || '');
        const urlWithoutQuery = String(imageUrl || '').split('?')[0].split('#')[0];
        const extMatch = urlWithoutQuery.match(/\.([a-zA-Z0-9]+)$/);
        const ext = extMatch ? extMatch[1] : 'jpg';

        return `robomd_ai_studio${seq ? `_${seq}` : ''}.${ext}`;
    };

    downloadStepImage = async (step, event) => {
        if (event) event.stopPropagation();
        if (this.state.tutorialDemoMode) return;

        const imageUrl = this.getStepGeneratedImageUrl(step);
        if (!imageUrl) {
            // window.alert('다운로드할 이미지가 없습니다.');
            this.setState({
                warning_dialog_show_state: true,
                warning_dialog_content: "다운로드할 이미지가 없습니다.",
                warning_dialog_button_list: [
                    {
                        title: "확인",
                        event_method: () => {
                            this.setState({ warning_dialog_show_state: false });
                        }
                    }
                ]
            });
            return;
        }

        const downloadFileName = this.getStepDownloadFileName(step, imageUrl);

        try {
            const cacheBuster = imageUrl.includes('?') ? `&t=${new Date().getTime()}` : `?t=${new Date().getTime()}`;
            const fetchUrl = imageUrl + cacheBuster;

            const response = await fetch(fetchUrl, {
                mode: 'cors',
            });

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }

            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = downloadFileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error('이미지 다운로드 실패', error);

            // fetch/blob 다운로드가 막히는 경우 새 창으로라도 열기
            const link = document.createElement('a');
            link.href = imageUrl;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            link.download = downloadFileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    extractRawUrl = (wrappedUrl) => {
        if (!wrappedUrl) return '';
        return String(wrappedUrl)
            .replace(/^url\(['"]?/, '')
            .replace(/['"]?\)$/, '');
    };

    getImageAspectRatio = (imageUrl) => {
        return new Promise((resolve) => {
            if (!imageUrl) {
                resolve('');
                return;
            }

            const img = new Image();

            img.onload = () => {
                if (img.naturalWidth && img.naturalHeight) {
                    resolve(`${img.naturalWidth} / ${img.naturalHeight}`);
                } else {
                    resolve('');
                }
            };

            img.onerror = () => {
                resolve('');
            };

            img.src = imageUrl;
        });
    };

    ensureStepPreviewRatio = async (stepId) => {
        const step = this.state.steps.find((item) => item.id === stepId);
        if (!step) return;

        const previewWrappedUrl = this.getStepResultUrl(step);
        const previewRawUrl = this.extractRawUrl(previewWrappedUrl);

        if (!previewRawUrl) return;
        if (step.historyRatioMap && step.historyRatioMap[previewRawUrl]) return;

        const aspectRatio = await this.getImageAspectRatio(previewRawUrl);
        if (!aspectRatio) return;

        this.setState((prevState) => ({
            steps: prevState.steps.map((item) => {
                if (item.id !== stepId) return item;

                if (item.historyRatioMap && item.historyRatioMap[previewRawUrl]) {
                    return item;
                }

                return {
                    ...item,
                    historyRatioMap: {
                        ...(item.historyRatioMap || {}),
                        [previewRawUrl]: aspectRatio,
                    },
                };
            }),
        }));
    };

    ensureVisiblePreviewRatios = async (stepIdList) => {
        const targets = (stepIdList || []).filter(Boolean);

        for (const stepId of targets) {
            await this.ensureStepPreviewRatio(stepId);
        }
    };

    groupHistoryByDate = (historyItems) => {
        const grouped = {};
        const today = new Date();

        historyItems.forEach((item) => {
            const date = this.parseHistoryDate(item.mod_date);

            let key = '날짜없음';

            if (date) {
                const isToday =
                    date.getFullYear() === today.getFullYear() &&
                    date.getMonth() === today.getMonth() &&
                    date.getDate() === today.getDate();

                key = isToday
                    ? '오늘'
                    : `${date.getFullYear()}.${String(date.getMonth() + 1).padStart(2, '0')}.${String(date.getDate()).padStart(2, '0')}`;
            }

            if (!grouped[key]) {
                grouped[key] = [];
            }

            grouped[key].push(item);
        });

        return grouped;
    };

    parseHistoryDate = (dateString) => {
        if (!dateString) return null;

        const normalized = String(dateString).replace(
            /([+-]\d{2})(\d{2})$/,
            '$1:$2'
        );

        const date = new Date(normalized);

        if (isNaN(date.getTime())) {
            return null;
        }

        return date;
    };

    resizeAllTextareas = () => {
        const textareas = document.querySelectorAll('.prompt-textarea');

        textareas.forEach((textarea) => {
            this.applyTextareaLayout(textarea);
        });
    };

    getTextareaVisualLineCount = (textarea) => {
        if (!textarea) return 1;

        const style = window.getComputedStyle(textarea);
        const value = textarea.value || '';

        const mirror = document.createElement('div');
        mirror.style.position = 'absolute';
        mirror.style.visibility = 'hidden';
        mirror.style.pointerEvents = 'none';
        mirror.style.zIndex = '-1';
        mirror.style.whiteSpace = 'pre-wrap';
        mirror.style.wordBreak = 'break-word';
        mirror.style.boxSizing = style.boxSizing;
        mirror.style.width = textarea.clientWidth + 'px';

        mirror.style.fontSize = style.fontSize;
        mirror.style.fontFamily = style.fontFamily;
        mirror.style.fontWeight = style.fontWeight;
        mirror.style.lineHeight = style.lineHeight;
        mirror.style.letterSpacing = style.letterSpacing;
        mirror.style.paddingTop = '0px';
        mirror.style.paddingBottom = '0px';
        mirror.style.paddingLeft = style.paddingLeft;
        mirror.style.paddingRight = style.paddingRight;
        mirror.style.border = '0';

        // 🔥 핵심: value 없으면 placeholder 사용
        const text = value ? value : (textarea.placeholder || '');

        // 🔥 마지막 줄 유지용 zero-width space
        mirror.textContent = text + '\u200B';

        document.body.appendChild(mirror);

        let lineHeight = parseFloat(style.lineHeight);
        if (isNaN(lineHeight)) {
            const fontSize = parseFloat(style.fontSize) || 16;
            lineHeight = fontSize * 1.5;
        }

        const lineCount = Math.max(1, Math.round(mirror.offsetHeight / lineHeight));

        document.body.removeChild(mirror);

        return lineCount;
    };

    applyTextareaLayout = (textarea) => {
        if (!textarea) return;

        const AUTO_MAX_HEIGHT = 200;
        const style = window.getComputedStyle(textarea);
        const fontSize = parseFloat(style.fontSize) || 16;
        const lineHeightValue = parseFloat(style.lineHeight) || (fontSize * 1.5);
        const lineCount = this.getTextareaVisualLineCount(textarea);
        const manualHeight = parseFloat(textarea.dataset.manualHeight || '0') || 0;

        textarea.style.height = 'auto';

        const contentHeight = lineCount <= 2
            ? lineHeightValue * Math.max(lineCount, 1)
            : textarea.scrollHeight;
        const autoHeight = Math.min(contentHeight, AUTO_MAX_HEIGHT);

        // 자동 증가는 200px까지만 허용하고,
        // 사용자가 우측 하단에서 직접 늘린 높이는 제한 없이 유지한다.
        const finalHeight = Math.max(autoHeight, manualHeight);

        textarea.style.height = finalHeight + 'px';
        textarea.style.overflowY = textarea.scrollHeight > finalHeight ? 'auto' : 'hidden';
    };

    renderStudioContent = () => {
        const { isModalOpen, isApplied, appliedPrompts, appliedThumb, steps, historyItems, activeTopTab, isMobileHistoryOpen } = this.state;
        const groupedHistory = this.groupHistoryByDate(historyItems);
        const isAutomationProtected = this.isCurrentHistoryAutomationProtected();
        const isAutomationEditBlocked = this.isCurrentHistoryEditBlocked();

        return (
            <div className={`modal-box ${this.isPopupMode() ? '' : 'full-page-mode'}`}>
                <div className="studio-header">
                    <div className="studio-logo">
                        <img src="https://robomd.io/images/home/logo_favicon.svg" alt="logo" style={{ width: '24px', height: '24px' }} />
                        AI 이미지
                        {/* <span style={{ background: 'white', color: 'var(--deep-navy)', padding: '2px 6px', borderRadius: '4px', fontSize: '12px', marginLeft: '4px' }}>PRO</span> */}
                        <button
                            type="button"
                            className="btn btn-sm btn-outline mobile-history-btn"
                            onClick={this.toggleMobileHistory}
                        >
                            히스토리
                        </button>
                    </div>

                    {/* <div className="studio-top-nav">
                        <button type="button" className={activeTopTab === 'studio' ? 'active' : ''} onClick={() => this.setState({ activeTopTab: 'studio' })}>작업 스튜디오</button>
                        <button type="button" className={activeTopTab === 'archive' ? 'active' : ''} onClick={() => this.setState({ activeTopTab: 'archive' })}>내 보관함</button>
                    </div> */}

                    {this.isPopupMode() ? (
                        <div style={{ cursor: 'pointer', fontSize: '28px', color: 'var(--text-light)' }} onClick={this.closeModal}>✕</div>
                    ) : null}
                </div>

                <div className={`studio-body ${this.isPopupMode() ? 'popup-mode' : ''}`}>
                    <div className={`studio-sidebar ${isMobileHistoryOpen ? 'mobile-open' : ''}`}>
                        <div className="sidebar-header">
                            <button type="button" className="new-chat-btn" onClick={this.startNewWorkflow}>
                                <span>새 작업 시작</span>
                                <img src="https://robomd.io/static/media/default_plus.466aee97.svg" alt="+" style={{ width: '20px', height: '20px' }} />
                            </button>
                        </div>
                        <div className="history-filter-wrap">
                            <button
                                data-instagram-tutorial-target="AI_STUDIO_HISTORY_MY"
                                className={`history-filter-btn ${this.state.auto_yn === 'N' ? 'active' : ''}`}
                                onClick={() => 
                                    this.setState({ auto_yn: 'N' }, () =>
                                        this.loadHistoryList(this.state.auto_yn)
                                    )
                                }
                            >
                                내 히스토리
                            </button>

                            <button
                                data-instagram-tutorial-target="AI_STUDIO_HISTORY_AUTO"
                                className={`history-filter-btn ${this.state.auto_yn === 'Y' ? 'active' : ''}`}
                                onClick={() => {
                                    this.setState({ auto_yn: 'Y' }, () =>
                                        this.loadHistoryList(this.state.auto_yn)
                                    )
                                }}
                            >
                                자동 히스토리
                            </button>
                        </div>
                        <div className="history-list">
                            {Object.keys(groupedHistory).map((groupKey) => (
                                <React.Fragment key={groupKey}>
                                    <div className="history-group-title">{groupKey}</div>

                                    {groupedHistory[groupKey].map((item) => {
                                        const historySeq = item.ai_studio_history_seq;
                                        const isActive =
                                            String(this.state.selectedHistorySeq || '') === String(historySeq || '');
                                        const isMenuOpen =
                                            String(this.state.historyMenuSeq || '') === String(historySeq || '');

                                        return (
                                            <div
                                                key={historySeq}
                                                className={`history-item ${isActive ? 'active' : ''}`}
                                                onClick={() => this.handleHistoryItemClick(item)}
                                                title={item.history_title || 'AI 스튜디오 히스토리'}
                                            >
                                                <div className="history-item-text">
                                                    {item.history_title || '새 작업'}
                                                </div>
                                                <span className="history-menu-wrap">
                                                    <button
                                                        type="button"
                                                        className="history-menu-trigger"
                                                        aria-label="히스토리 메뉴"
                                                        onClick={(event) => this.toggleHistoryMenu(event, item)}
                                                    >
                                                        ⋯
                                                    </button>
                                                    {isMenuOpen ? (
                                                        <span
                                                            className="history-menu"
                                                            onClick={(event) => event.stopPropagation()}
                                                        >
                                                            <button
                                                                type="button"
                                                                onClick={(event) => this.handleHistoryRename(event, item)}
                                                            >
                                                                이름 변경
                                                            </button>
                                                            <button
                                                                type="button"
                                                                onClick={(event) => this.handleHistoryDuplicate(event, item)}
                                                            >
                                                                새 작업으로 복제
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="delete"
                                                                onClick={(event) => this.handleHistoryDelete(event, item)}
                                                            >
                                                                삭제
                                                            </button>
                                                        </span>
                                                    ) : null}
                                                </span>
                                            </div>
                                        );
                                    })}
                                </React.Fragment>
                            ))}
                        </div>
                        {
                            this.state.aiUsage["is_api_limit_apply_yn"] === 'Y' && 
                            <div className="usage-summary-box">
                                <div className="usage-summary-title">
                                    AI 사용량
                                </div>
                                <div className="usage-summary-body">
                                    {this.state.aiUsageLoading ? (
                                        <span className="usage-loading-text">불러오는 중...</span>
                                    ) : (
                                        <>
                                            <div className="usage-metric-group">
                                                <span className="usage-metric-label">이미지 생성</span>
                                                <span className="usage-main-text">
                                                    {Number(this.state.aiUsage.total_used_nanobanana_call_count || 0).toLocaleString()}
                                                    <span className="usage-separator"> / </span>
                                                    {Number(this.state.aiUsage.total_available_nanobanana_call_count || 0).toLocaleString()}
                                                </span>
                                                <span className="usage-sub-text">
                                                    남은 횟수 {Number(this.state.aiUsage.max_available_nanobanana_call_count || 0).toLocaleString()}회
                                                </span>
                                            </div>

                                            {this.state.aiUsage.gpt_web_search_limit_apply_yn === 'Y' ? (
                                                <>
                                                    <div className="usage-summary-divider" />

                                                    <div className="usage-metric-group">
                                                        <span className="usage-metric-label">웹검색 활용</span>
                                                        <span className="usage-main-text">
                                                            {Number(this.state.aiUsage.total_used_gpt_web_search_call_count || 0).toLocaleString()}
                                                            <span className="usage-separator"> / </span>
                                                            {Number(this.state.aiUsage.total_available_gpt_web_search_call_count || 0).toLocaleString()}
                                                        </span>
                                                        <span className="usage-sub-text">
                                                            남은 횟수 {Number(this.state.aiUsage.max_available_gpt_web_search_call_count || 0).toLocaleString()}회
                                                        </span>
                                                    </div>
                                                </>
                                            ) : null}
                                        </>
                                    )}
                                </div>
                            </div>
                        }
                    </div>

                    <div className="studio-main-wrap">
                        {isAutomationProtected ? (
                            <div className="automation-use-warning">
                                {/* <strong>AI콘텐츠 자동화에서 사용 중인 작업입니다.</strong>
                                <span className="automation-use-warning-text">
                                    이 작업을 수정하면 현재 사용 중인 다른 자동화에도 변경 내용이 반영될 수 있습니다. 기존 자동화에 영향을 주지 않으려면 새 작업으로 복제해서 사용해 주세요.
                                </span> */}
                                <strong>AI 콘텐츠 자동화에 사용 중인 작업입니다.</strong>
                                <span className="automation-use-warning-text">
                                    수정한 내용은 이후 자동 생성되는 콘텐츠에 반영됩니다. 기존 자동화에 영향을 주지 않으려면 새 작업으로 복제해서 사용해 주세요.
                                </span>
                                <button
                                    type="button"
                                    className="automation-use-warning-button"
                                    disabled={this.state.historyActionProcessing}
                                    onClick={(e) => this.handleHistoryDuplicate(e, {
                                        ai_studio_history_seq: this.state.ai_studio_history_seq,
                                        history_title: this.state.workflowTitle,
                                    })}
                                >
                                    새 작업으로 복제
                                </button>
                            </div>
                        ) : null}

                        <div className="chat-feed" id="chatFeed">
                            {steps.map((step, index) => this.renderStepNode(step, index))}
                        </div>

                        <div className="workspace-footer" data-instagram-tutorial-target="AI_STUDIO_FOOTER">
                            {this.isPopupMode() ? (
                                this.isOpenedFromAiStudioList()
                                ?
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flex: 1}}>
                                        <div style={{ width: '48px', height: '48px', background: 'rgba(0,226,230,0.1)', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--primary-mint-hover)' }}>
                                            {/* ⚙️ */}
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M22.2655 9.77814C22.2422 9.6733 22.1966 9.57468 22.1319 9.48896C22.0672 9.40324 21.9849 9.33241 21.8905 9.28126L19.6592 8.04376C19.5396 7.80123 19.405 7.5664 19.2561 7.34064L19.303 4.79064C19.3038 4.68368 19.2826 4.5777 19.2407 4.4793C19.1987 4.38091 19.137 4.29221 19.0592 4.21876C17.9482 3.21148 16.6344 2.45386 15.2061 1.99689C15.1035 1.96491 14.9953 1.95505 14.8887 1.96798C14.782 1.98091 14.6793 2.01633 14.5873 2.07189L12.403 3.38439C12.1311 3.37501 11.8686 3.37501 11.5967 3.38439L9.41233 2.07189C9.32037 2.01633 9.21766 1.98091 9.111 1.96798C9.00434 1.95505 8.89615 1.96491 8.79358 1.99689C7.36339 2.45421 6.04898 3.21535 4.94045 4.22814C4.86202 4.29906 4.79969 4.38596 4.75765 4.48298C4.7156 4.58001 4.69482 4.68491 4.6967 4.79064L4.74358 7.34064C4.59358 7.56564 4.46233 7.80001 4.33108 8.04376L2.09983 9.28126C2.00675 9.33294 1.92591 9.40408 1.86282 9.48982C1.79972 9.57557 1.75585 9.67391 1.7342 9.77814C1.41542 11.2422 1.41542 12.7578 1.7342 14.2219C1.75749 14.3267 1.80302 14.4253 1.86772 14.5111C1.93241 14.5968 2.01477 14.6676 2.1092 14.7188L4.34045 15.9563C4.46006 16.1988 4.5947 16.4336 4.74358 16.6594L4.6967 19.2094C4.69584 19.3163 4.71705 19.4223 4.75899 19.5207C4.80093 19.6191 4.8627 19.7078 4.94045 19.7813C6.05142 20.7885 7.36527 21.5462 8.79358 22.0031C8.89615 22.0351 9.00434 22.045 9.111 22.032C9.21766 22.0191 9.32037 21.9837 9.41233 21.9281L11.5967 20.6156H12.403L14.5967 21.9281C14.7107 22.0031 14.8446 22.0423 14.9811 22.0406C15.0573 22.0373 15.1329 22.0248 15.2061 22.0031C16.6363 21.5458 17.9507 20.7847 19.0592 19.7719C19.1376 19.701 19.2 19.6141 19.242 19.517C19.2841 19.42 19.3048 19.3151 19.303 19.2094L19.2561 16.6594C19.4061 16.4344 19.5373 16.2 19.6686 15.9563L21.8998 14.7188C21.9929 14.6671 22.0737 14.596 22.1368 14.5102C22.1999 14.4245 22.2438 14.3261 22.2655 14.2219C22.5842 12.7578 22.5842 11.2422 22.2655 9.77814ZM20.8592 13.575L18.7311 14.7563C18.5961 14.8347 18.4882 14.9525 18.4217 15.0938C18.2675 15.4133 18.0888 15.7205 17.8873 16.0125C17.8017 16.1435 17.7561 16.2966 17.7561 16.4531L17.7936 18.8813C16.9864 19.5685 16.0624 20.1052 15.0655 20.4656L12.9748 19.2094C12.8581 19.1415 12.7255 19.1059 12.5905 19.1063H12.5342C12.1785 19.1344 11.8211 19.1344 11.4655 19.1063C11.3117 19.0979 11.1588 19.1337 11.0248 19.2094L8.9342 20.4656C7.93847 20.1069 7.01464 19.5736 6.20608 18.8906L6.24358 16.4531C6.24352 16.2966 6.19791 16.1435 6.11233 16.0125C5.91428 15.7183 5.73577 15.4114 5.57795 15.0938C5.50873 14.9543 5.40148 14.8373 5.26858 14.7563L3.14045 13.575C2.95289 12.5334 2.95289 11.4666 3.14045 10.425L5.26858 9.24376C5.40359 9.1653 5.5115 9.04757 5.57795 8.90626C5.73219 8.58673 5.91084 8.27957 6.11233 7.98751C6.19791 7.85649 6.24352 7.70339 6.24358 7.54689L6.20608 5.11876C7.01322 4.43151 7.93727 3.89486 8.9342 3.53439L11.0248 4.79064C11.1584 4.86738 11.3117 4.90324 11.4655 4.89376C11.8211 4.86563 12.1785 4.86563 12.5342 4.89376C12.6879 4.90216 12.8408 4.86637 12.9748 4.79064L15.0655 3.53439C16.0612 3.89312 16.985 4.42646 17.7936 5.10939L17.7561 7.54689C17.7561 7.70339 17.8017 7.85649 17.8873 7.98751C18.0854 8.28173 18.2639 8.58864 18.4217 8.90626C18.4909 9.0457 18.5982 9.1627 18.7311 9.24376L20.8592 10.425C21.0468 11.4666 21.0468 12.5334 20.8592 13.575ZM11.9998 6.75001C10.9615 6.75001 9.94644 7.05792 9.08308 7.6348C8.21973 8.21168 7.54682 9.03161 7.14946 9.99093C6.7521 10.9502 6.64813 12.0058 6.8507 13.0242C7.05328 14.0426 7.55329 14.9781 8.28752 15.7123C9.02174 16.4466 9.9572 16.9466 10.9756 17.1491C11.994 17.3517 13.0496 17.2477 14.0089 16.8504C14.9682 16.453 15.7882 15.7801 16.365 14.9168C16.9419 14.0534 17.2498 13.0384 17.2498 12C17.2498 10.6076 16.6967 9.27227 15.7121 8.2877C14.7276 7.30314 13.3922 6.75001 11.9998 6.75001ZM11.9998 15.75C11.2581 15.75 10.5331 15.5301 9.91644 15.118C9.29975 14.706 8.81911 14.1203 8.53528 13.4351C8.25145 12.7499 8.17719 11.9959 8.32188 11.2684C8.46658 10.541 8.82373 9.87281 9.34818 9.34836C9.87262 8.82392 10.5408 8.46676 11.2682 8.32207C11.9957 8.17737 12.7497 8.25164 13.4349 8.53547C14.1201 8.81929 14.7058 9.29994 15.1178 9.91663C15.5299 10.5333 15.7498 11.2583 15.7498 12C15.7498 12.9946 15.3547 13.9484 14.6515 14.6517C13.9482 15.3549 12.9944 15.75 11.9998 15.75Z" fill="#333333"/>
                                            </svg>
                                        </div>
                                        <div style={{ textAlign: 'left' }}>
                                            <div style={{ fontSize: '16px', fontWeight: 800, color: 'var(--deep-navy)' }}>
                                                어디에 적용할까요?
                                            </div>
                                            <div style={{ fontSize: '14px', color: 'var(--text-sub)' }}>
                                                현재 이미지는 게시물 등록에, 전체 작업 과정은 자동화 규칙에 적용할 수 있어요.
                                            </div>
                                        </div>
                                    </div>
                                : this.getAiResponseType() == "IMAGE"
                                ?
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flex: 1}}>
                                        <div style={{ width: '48px', height: '48px', background: 'rgba(0,226,230,0.1)', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--primary-mint-hover)' }}>
                                            {/* ⚙️ */}
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M22.2655 9.77814C22.2422 9.6733 22.1966 9.57468 22.1319 9.48896C22.0672 9.40324 21.9849 9.33241 21.8905 9.28126L19.6592 8.04376C19.5396 7.80123 19.405 7.5664 19.2561 7.34064L19.303 4.79064C19.3038 4.68368 19.2826 4.5777 19.2407 4.4793C19.1987 4.38091 19.137 4.29221 19.0592 4.21876C17.9482 3.21148 16.6344 2.45386 15.2061 1.99689C15.1035 1.96491 14.9953 1.95505 14.8887 1.96798C14.782 1.98091 14.6793 2.01633 14.5873 2.07189L12.403 3.38439C12.1311 3.37501 11.8686 3.37501 11.5967 3.38439L9.41233 2.07189C9.32037 2.01633 9.21766 1.98091 9.111 1.96798C9.00434 1.95505 8.89615 1.96491 8.79358 1.99689C7.36339 2.45421 6.04898 3.21535 4.94045 4.22814C4.86202 4.29906 4.79969 4.38596 4.75765 4.48298C4.7156 4.58001 4.69482 4.68491 4.6967 4.79064L4.74358 7.34064C4.59358 7.56564 4.46233 7.80001 4.33108 8.04376L2.09983 9.28126C2.00675 9.33294 1.92591 9.40408 1.86282 9.48982C1.79972 9.57557 1.75585 9.67391 1.7342 9.77814C1.41542 11.2422 1.41542 12.7578 1.7342 14.2219C1.75749 14.3267 1.80302 14.4253 1.86772 14.5111C1.93241 14.5968 2.01477 14.6676 2.1092 14.7188L4.34045 15.9563C4.46006 16.1988 4.5947 16.4336 4.74358 16.6594L4.6967 19.2094C4.69584 19.3163 4.71705 19.4223 4.75899 19.5207C4.80093 19.6191 4.8627 19.7078 4.94045 19.7813C6.05142 20.7885 7.36527 21.5462 8.79358 22.0031C8.89615 22.0351 9.00434 22.045 9.111 22.032C9.21766 22.0191 9.32037 21.9837 9.41233 21.9281L11.5967 20.6156H12.403L14.5967 21.9281C14.7107 22.0031 14.8446 22.0423 14.9811 22.0406C15.0573 22.0373 15.1329 22.0248 15.2061 22.0031C16.6363 21.5458 17.9507 20.7847 19.0592 19.7719C19.1376 19.701 19.2 19.6141 19.242 19.517C19.2841 19.42 19.3048 19.3151 19.303 19.2094L19.2561 16.6594C19.4061 16.4344 19.5373 16.2 19.6686 15.9563L21.8998 14.7188C21.9929 14.6671 22.0737 14.596 22.1368 14.5102C22.1999 14.4245 22.2438 14.3261 22.2655 14.2219C22.5842 12.7578 22.5842 11.2422 22.2655 9.77814ZM20.8592 13.575L18.7311 14.7563C18.5961 14.8347 18.4882 14.9525 18.4217 15.0938C18.2675 15.4133 18.0888 15.7205 17.8873 16.0125C17.8017 16.1435 17.7561 16.2966 17.7561 16.4531L17.7936 18.8813C16.9864 19.5685 16.0624 20.1052 15.0655 20.4656L12.9748 19.2094C12.8581 19.1415 12.7255 19.1059 12.5905 19.1063H12.5342C12.1785 19.1344 11.8211 19.1344 11.4655 19.1063C11.3117 19.0979 11.1588 19.1337 11.0248 19.2094L8.9342 20.4656C7.93847 20.1069 7.01464 19.5736 6.20608 18.8906L6.24358 16.4531C6.24352 16.2966 6.19791 16.1435 6.11233 16.0125C5.91428 15.7183 5.73577 15.4114 5.57795 15.0938C5.50873 14.9543 5.40148 14.8373 5.26858 14.7563L3.14045 13.575C2.95289 12.5334 2.95289 11.4666 3.14045 10.425L5.26858 9.24376C5.40359 9.1653 5.5115 9.04757 5.57795 8.90626C5.73219 8.58673 5.91084 8.27957 6.11233 7.98751C6.19791 7.85649 6.24352 7.70339 6.24358 7.54689L6.20608 5.11876C7.01322 4.43151 7.93727 3.89486 8.9342 3.53439L11.0248 4.79064C11.1584 4.86738 11.3117 4.90324 11.4655 4.89376C11.8211 4.86563 12.1785 4.86563 12.5342 4.89376C12.6879 4.90216 12.8408 4.86637 12.9748 4.79064L15.0655 3.53439C16.0612 3.89312 16.985 4.42646 17.7936 5.10939L17.7561 7.54689C17.7561 7.70339 17.8017 7.85649 17.8873 7.98751C18.0854 8.28173 18.2639 8.58864 18.4217 8.90626C18.4909 9.0457 18.5982 9.1627 18.7311 9.24376L20.8592 10.425C21.0468 11.4666 21.0468 12.5334 20.8592 13.575ZM11.9998 6.75001C10.9615 6.75001 9.94644 7.05792 9.08308 7.6348C8.21973 8.21168 7.54682 9.03161 7.14946 9.99093C6.7521 10.9502 6.64813 12.0058 6.8507 13.0242C7.05328 14.0426 7.55329 14.9781 8.28752 15.7123C9.02174 16.4466 9.9572 16.9466 10.9756 17.1491C11.994 17.3517 13.0496 17.2477 14.0089 16.8504C14.9682 16.453 15.7882 15.7801 16.365 14.9168C16.9419 14.0534 17.2498 13.0384 17.2498 12C17.2498 10.6076 16.6967 9.27227 15.7121 8.2877C14.7276 7.30314 13.3922 6.75001 11.9998 6.75001ZM11.9998 15.75C11.2581 15.75 10.5331 15.5301 9.91644 15.118C9.29975 14.706 8.81911 14.1203 8.53528 13.4351C8.25145 12.7499 8.17719 11.9959 8.32188 11.2684C8.46658 10.541 8.82373 9.87281 9.34818 9.34836C9.87262 8.82392 10.5408 8.46676 11.2682 8.32207C11.9957 8.17737 12.7497 8.25164 13.4349 8.53547C14.1201 8.81929 14.7058 9.29994 15.1178 9.91663C15.5299 10.5333 15.7498 11.2583 15.7498 12C15.7498 12.9946 15.3547 13.9484 14.6515 14.6517C13.9482 15.3549 12.9944 15.75 11.9998 15.75Z" fill="#333333"/>
                                            </svg>
                                        </div>
                                        <div style={{ textAlign: 'left' }}>
                                            <div style={{ fontSize: '16px', fontWeight: 800, color: 'var(--deep-navy)' }}>
                                                선택한 이미지를 적용해볼까요?
                                            </div>
                                            <div style={{ fontSize: '14px', color: 'var(--text-sub)' }}>
                                                지금 보고 있는 이미지를 바로 적용할 수 있어요.
                                            </div>
                                        </div>
                                    </div>
                                :
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flex: 1}}>
                                        <div style={{ width: '48px', height: '48px', background: 'rgba(0,226,230,0.1)', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--primary-mint-hover)' }}>
                                            {/* ⚙️ */}
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M22.2655 9.77814C22.2422 9.6733 22.1966 9.57468 22.1319 9.48896C22.0672 9.40324 21.9849 9.33241 21.8905 9.28126L19.6592 8.04376C19.5396 7.80123 19.405 7.5664 19.2561 7.34064L19.303 4.79064C19.3038 4.68368 19.2826 4.5777 19.2407 4.4793C19.1987 4.38091 19.137 4.29221 19.0592 4.21876C17.9482 3.21148 16.6344 2.45386 15.2061 1.99689C15.1035 1.96491 14.9953 1.95505 14.8887 1.96798C14.782 1.98091 14.6793 2.01633 14.5873 2.07189L12.403 3.38439C12.1311 3.37501 11.8686 3.37501 11.5967 3.38439L9.41233 2.07189C9.32037 2.01633 9.21766 1.98091 9.111 1.96798C9.00434 1.95505 8.89615 1.96491 8.79358 1.99689C7.36339 2.45421 6.04898 3.21535 4.94045 4.22814C4.86202 4.29906 4.79969 4.38596 4.75765 4.48298C4.7156 4.58001 4.69482 4.68491 4.6967 4.79064L4.74358 7.34064C4.59358 7.56564 4.46233 7.80001 4.33108 8.04376L2.09983 9.28126C2.00675 9.33294 1.92591 9.40408 1.86282 9.48982C1.79972 9.57557 1.75585 9.67391 1.7342 9.77814C1.41542 11.2422 1.41542 12.7578 1.7342 14.2219C1.75749 14.3267 1.80302 14.4253 1.86772 14.5111C1.93241 14.5968 2.01477 14.6676 2.1092 14.7188L4.34045 15.9563C4.46006 16.1988 4.5947 16.4336 4.74358 16.6594L4.6967 19.2094C4.69584 19.3163 4.71705 19.4223 4.75899 19.5207C4.80093 19.6191 4.8627 19.7078 4.94045 19.7813C6.05142 20.7885 7.36527 21.5462 8.79358 22.0031C8.89615 22.0351 9.00434 22.045 9.111 22.032C9.21766 22.0191 9.32037 21.9837 9.41233 21.9281L11.5967 20.6156H12.403L14.5967 21.9281C14.7107 22.0031 14.8446 22.0423 14.9811 22.0406C15.0573 22.0373 15.1329 22.0248 15.2061 22.0031C16.6363 21.5458 17.9507 20.7847 19.0592 19.7719C19.1376 19.701 19.2 19.6141 19.242 19.517C19.2841 19.42 19.3048 19.3151 19.303 19.2094L19.2561 16.6594C19.4061 16.4344 19.5373 16.2 19.6686 15.9563L21.8998 14.7188C21.9929 14.6671 22.0737 14.596 22.1368 14.5102C22.1999 14.4245 22.2438 14.3261 22.2655 14.2219C22.5842 12.7578 22.5842 11.2422 22.2655 9.77814ZM20.8592 13.575L18.7311 14.7563C18.5961 14.8347 18.4882 14.9525 18.4217 15.0938C18.2675 15.4133 18.0888 15.7205 17.8873 16.0125C17.8017 16.1435 17.7561 16.2966 17.7561 16.4531L17.7936 18.8813C16.9864 19.5685 16.0624 20.1052 15.0655 20.4656L12.9748 19.2094C12.8581 19.1415 12.7255 19.1059 12.5905 19.1063H12.5342C12.1785 19.1344 11.8211 19.1344 11.4655 19.1063C11.3117 19.0979 11.1588 19.1337 11.0248 19.2094L8.9342 20.4656C7.93847 20.1069 7.01464 19.5736 6.20608 18.8906L6.24358 16.4531C6.24352 16.2966 6.19791 16.1435 6.11233 16.0125C5.91428 15.7183 5.73577 15.4114 5.57795 15.0938C5.50873 14.9543 5.40148 14.8373 5.26858 14.7563L3.14045 13.575C2.95289 12.5334 2.95289 11.4666 3.14045 10.425L5.26858 9.24376C5.40359 9.1653 5.5115 9.04757 5.57795 8.90626C5.73219 8.58673 5.91084 8.27957 6.11233 7.98751C6.19791 7.85649 6.24352 7.70339 6.24358 7.54689L6.20608 5.11876C7.01322 4.43151 7.93727 3.89486 8.9342 3.53439L11.0248 4.79064C11.1584 4.86738 11.3117 4.90324 11.4655 4.89376C11.8211 4.86563 12.1785 4.86563 12.5342 4.89376C12.6879 4.90216 12.8408 4.86637 12.9748 4.79064L15.0655 3.53439C16.0612 3.89312 16.985 4.42646 17.7936 5.10939L17.7561 7.54689C17.7561 7.70339 17.8017 7.85649 17.8873 7.98751C18.0854 8.28173 18.2639 8.58864 18.4217 8.90626C18.4909 9.0457 18.5982 9.1627 18.7311 9.24376L20.8592 10.425C21.0468 11.4666 21.0468 12.5334 20.8592 13.575ZM11.9998 6.75001C10.9615 6.75001 9.94644 7.05792 9.08308 7.6348C8.21973 8.21168 7.54682 9.03161 7.14946 9.99093C6.7521 10.9502 6.64813 12.0058 6.8507 13.0242C7.05328 14.0426 7.55329 14.9781 8.28752 15.7123C9.02174 16.4466 9.9572 16.9466 10.9756 17.1491C11.994 17.3517 13.0496 17.2477 14.0089 16.8504C14.9682 16.453 15.7882 15.7801 16.365 14.9168C16.9419 14.0534 17.2498 13.0384 17.2498 12C17.2498 10.6076 16.6967 9.27227 15.7121 8.2877C14.7276 7.30314 13.3922 6.75001 11.9998 6.75001ZM11.9998 15.75C11.2581 15.75 10.5331 15.5301 9.91644 15.118C9.29975 14.706 8.81911 14.1203 8.53528 13.4351C8.25145 12.7499 8.17719 11.9959 8.32188 11.2684C8.46658 10.541 8.82373 9.87281 9.34818 9.34836C9.87262 8.82392 10.5408 8.46676 11.2682 8.32207C11.9957 8.17737 12.7497 8.25164 13.4349 8.53547C14.1201 8.81929 14.7058 9.29994 15.1178 9.91663C15.5299 10.5333 15.7498 11.2583 15.7498 12C15.7498 12.9946 15.3547 13.9484 14.6515 14.6517C13.9482 15.3549 12.9944 15.75 11.9998 15.75Z" fill="#333333"/>
                                            </svg>
                                        </div>
                                        <div style={{ textAlign: 'left' }}>
                                            <div style={{ fontSize: '16px', fontWeight: 800, color: 'var(--deep-navy)' }}>설정이 완료되셨나요?</div>
                                            <div style={{ fontSize: '14px', color: 'var(--text-sub)' }}>전체 작업 과정을 자동화 규칙으로 적용할 수 있어요.</div>
                                        </div>
                                    </div>
                            ) : <div></div>}
                            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap', alignItems: 'center' }}>
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-instagram-tutorial-target="AI_STUDIO_FOOTER_RUN_ALL"
                                    style={{ padding: '0 28px', display: 'none' }}
                                    disabled={isAutomationEditBlocked}
                                    onClick={this.runAllSteps}
                                >
                                    <svg class="svg-icon-sm" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.3665 22.2L20.6043 14.0016C20.9531 13.7967 21.2424 13.5042 21.4433 13.1532C21.6443 12.8021 21.75 12.4046 21.75 12C21.75 11.5955 21.6443 11.198 21.4433 10.8469C21.2424 10.4958 20.9531 10.2033 20.6043 9.99847L6.3665 1.80003C6.02911 1.60291 5.64538 1.49902 5.25463 1.49902C4.86387 1.49902 4.48014 1.60291 4.14275 1.80003C3.79176 2.0022 3.5009 2.29416 3.30006 2.64592C3.09922 2.99768 2.99564 3.39656 2.99994 3.80159L2.99994 20.1985C2.99597 20.6032 3.09972 21.0017 3.30054 21.3531C3.50136 21.7045 3.79204 21.9961 4.14275 22.1982C4.47998 22.3956 4.86362 22.4998 5.25437 22.5001C5.64513 22.5004 6.02895 22.3969 6.3665 22.2ZM4.89369 20.8997C4.77177 20.8282 4.67105 20.7256 4.60186 20.6024C4.53267 20.4792 4.49749 20.3398 4.49994 20.1985L4.49994 3.80159C4.49749 3.66029 4.53267 3.52088 4.60186 3.39765C4.67105 3.27442 4.77177 3.17181 4.89369 3.10034C5.0033 3.0356 5.12827 3.00145 5.25556 3.00145C5.38286 3.00145 5.50783 3.0356 5.61744 3.10034L19.8553 11.2988C19.9766 11.3717 20.077 11.4748 20.1467 11.598C20.2164 11.7212 20.253 11.8603 20.253 12.0019C20.253 12.1435 20.2164 12.2826 20.1467 12.4058C20.077 12.529 19.9766 12.6321 19.8553 12.705L5.61744 20.9035C5.5075 20.9676 5.38235 21.0011 5.25505 21.0005C5.12775 20.9998 5.00296 20.965 4.89369 20.8997Z" fill="currentColor"></path>
                                    </svg>
                                    전체 연속 실행 (테스트)
                                </button>
                                {this.isPopupMode() && (
                                    this.isOpenedFromAiStudioList() ? (
                                        <>
                                            <button
                                                type="button"
                                                className="btn btn-outline"
                                                data-instagram-tutorial-target="AI_STUDIO_FOOTER_APPLY_RULE"
                                                onClick={() => this.applyToMain("PROMPT")}
                                                disabled={this.state.isApplyingRule || isAutomationEditBlocked}
                                            >
                                                자동화 적용
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-outline"
                                                data-instagram-tutorial-target="AI_STUDIO_FOOTER_REGISTER_IMAGE"
                                                onClick={() => this.applyToMain("IMAGE")}
                                                disabled={this.state.isApplyingRule || isAutomationEditBlocked}
                                            >
                                                콘텐츠 등록
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-save-workflow"
                                                data-instagram-tutorial-target="AI_STUDIO_FOOTER_SAVE"
                                                onClick={this.handleManualSave}
                                                disabled={this.state.isApplyingRule || this.state.isManuallySaving || isAutomationEditBlocked || this.state.tutorialDemoMode}
                                            >
                                                {this.state.isManuallySaving ? '저장 중...' : '저장'}
                                            </button>
                                        </>
                                    ) : (
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            data-instagram-tutorial-target={this.getAiResponseType() == "IMAGE" ? "AI_STUDIO_FOOTER_APPLY_IMAGE" : "AI_STUDIO_FOOTER_APPLY_RULE"}
                                            onClick={this.applyToMain}
                                            disabled={this.state.isApplyingRule || isAutomationEditBlocked}
                                        >
                                            <svg class="svg-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M13.2844 12.5344L9.34687 16.4719C9.20291 16.6095 9.01166 16.6867 8.8125 16.6875C8.66378 16.6873 8.51849 16.6428 8.3951 16.5598C8.27171 16.4768 8.17578 16.3589 8.11951 16.2213C8.06324 16.0836 8.04917 15.9323 8.07908 15.7867C8.10899 15.641 8.18154 15.5075 8.2875 15.4031L10.9406 12.75H2.25C2.05109 12.75 1.86032 12.671 1.71967 12.5303C1.57902 12.3897 1.5 12.1989 1.5 12C1.5 11.8011 1.57902 11.6103 1.71967 11.4697C1.86032 11.329 2.05109 11.25 2.25 11.25H10.9406L8.2875 8.59687C8.14577 8.45639 8.06566 8.26537 8.06478 8.06581C8.0639 7.86626 8.14233 7.67454 8.28281 7.53281C8.42329 7.39109 8.61432 7.31097 8.81387 7.31009C9.01342 7.30921 9.20515 7.38764 9.34687 7.52813L13.2844 11.4656C13.4252 11.6078 13.5042 11.7999 13.5042 12C13.5042 12.2001 13.4252 12.3922 13.2844 12.5344ZM18 3H12.75C12.5511 3 12.3603 3.07902 12.2197 3.21967C12.079 3.36032 12 3.55109 12 3.75C12 3.94891 12.079 4.13968 12.2197 4.28033C12.3603 4.42098 12.5511 4.5 12.75 4.5H18V19.5H12.75C12.5511 19.5 12.3603 19.579 12.2197 19.7197C12.079 19.8603 12 20.0511 12 20.25C12 20.4489 12.079 20.6397 12.2197 20.7803C12.3603 20.921 12.5511 21 12.75 21H18C18.3978 21 18.7794 20.842 19.0607 20.5607C19.342 20.2794 19.5 19.8978 19.5 19.5V4.5C19.5 4.10218 19.342 3.72064 19.0607 3.43934C18.7794 3.15804 18.3978 3 18 3Z" fill="currentColor"></path>
                                            </svg>
                                            {   this.getAiResponseType() == "IMAGE"
                                                ? '현재 선택된 이미지를 적용'
                                                : "자동화 적용"
                                            }
                                        </button>
                                    )
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    toggleMobileHistory = () => {
        this.setState((prevState) => ({
            isMobileHistoryOpen: !prevState.isMobileHistoryOpen,
        }));
    };

    closeMobileHistory = () => {
        this.setState({
            isMobileHistoryOpen: false,
        });
    };

    render() {
        return (
            <>
                <div
                    className="ai-image-studio-workflow"
                    data-instagram-tutorial-popup={this.isPopupMode() ? "POPUP_AI_STUDIO" : undefined}
                >
                    <style>{style_css}</style>

                    {this.isPopupMode() ? (
                        <div className="modal-overlay active">
                            {this.renderStudioContent()}
                            {this.state.isApplyingRule && (
                                <div className="apply-rule-loading-overlay">
                                    <div className="apply-rule-loading-box">
                                        <div className="apply-rule-loading-spinner" />
                                        <div className="apply-rule-loading-line1">
                                            {this.props.apply_rule_loading_line1 || '결과 이미지를 분석하고 있습니다.'}
                                        </div>
                                        <div className="apply-rule-loading-line2">
                                            {this.props.apply_rule_loading_line2 || '잠시만 기다려주세요.'}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    ) : (
                        this.renderStudioContent()
                    )}
                </div>
                {this.state.imageZoomUrl ? (
                    <div
                        className="image-zoom-overlay"
                        role="dialog"
                        aria-modal="true"
                        aria-label={this.state.imageZoomTitle || '이미지 확대'}
                        onClick={this.closeImageZoom}
                    >
                        <div className="image-zoom-dialog" onClick={(e) => e.stopPropagation()}>
                            <button
                                type="button"
                                className="image-zoom-close"
                                title="닫기"
                                aria-label="닫기"
                                onClick={this.closeImageZoom}
                            >
                                <i className="fa fa-solid fa-xmark" aria-hidden="true"></i>
                            </button>
                            {this.state.imageZoomTitle ? (
                                <div className="image-zoom-title">{this.state.imageZoomTitle}</div>
                            ) : null}
                            <img
                                className="image-zoom-image"
                                src={this.state.imageZoomUrl}
                                alt={this.state.imageZoomTitle || '확대 이미지'}
                            />
                        </div>
                    </div>
                ) : null}
                {this.state.historyRenameDialogOpen && this.state.historyRenameTarget ? (
                    <InputDialogV3
                        title="AI 스튜디오 히스토리 이름 변경"
                        content="변경할 히스토리 이름을 입력해주세요."
                        input_list={[
                            {
                                title: '히스토리 이름',
                                value: this.state.historyRenameTarget.history_title || '새 작업',
                                placeholder: '히스토리 이름을 입력해주세요.',
                            },
                        ]}
                        button_text="변경"
                        is_show_close={true}
                        onPopupClose={this.closeHistoryRenameDialog}
                        onButtonClick={this.confirmHistoryRename}
                    />
                ) : null}
                {this.state.historyDeleteDialogOpen && this.state.historyDeleteTarget ? (
                    <TitleContentDialogV2
                        title="AI 스튜디오 히스토리를 삭제하시겠습니까?"
                        content="삭제한 히스토리는 복구할 수 없습니다."
                        popup_close={this.closeHistoryDeleteDialog}
                        button_list={[
                            {
                                title: this.state.historyActionProcessing ? '삭제 중...' : '삭제',
                                event_method: this.deleteHistory,
                            },
                            {
                                title: '취소',
                                event_method: this.closeHistoryDeleteDialog,
                            },
                        ]}
                    />
                ) : null}
                {/* 경고 다이얼로그 */
                    this.state.warning_dialog_show_state === true &&
                    <WarningDialog
                        content={this.state.warning_dialog_content}
                        button_list={this.state.warning_dialog_button_list}
                        width_auto={this.state.warning_dialog_width_auto}
                    />
                }
                {this.state.save_dialog_show_state && <SaveDialogV2 id="save_dialog" content={this.state.save_dialog_content} button_list={this.state.save_dialog_button_list} />}
            </>
        );
    }
}
